export default {
  'data': {
    'person': [
      {
        'faculty': 'คณะวิทยาศาสตร์การกีฬาและสุขภาพ',
        'graduated': {
          'field': [ 'วิทยาศาสตรมหาบัณฑิต (วท.ม) สาขาวิชาสุขศึกษา', 'ครุศาสตรบัณฑิต (ค.บ) สาขาวิชาสุขศึกษา' ],
          'university': [ 'มหาวิทยาลัยมหิดล', 'สถาบันราชภัฏสุราษฏร์ธานี' ]
        },
        'name': 'นางลีนา  ทองมาก',
        'position': 'ผู้ช่วยศาสตราจารย์',
        'publish': {
          '2560': [
            {
              'link': '',
              'name': 'Kingpet Ngoenthong, et al. (2017). Physical Fitness Assessment of Students at The Institute of Physical Education, Sukhothai Campus. 7 th Institute of Physical Education International Conference     (pp. 78-87). Bangkok: Institute of Physical Education.',
              'year': 2560
            }
          ],
          '2561': [
            {
              'link': '',
              'name': 'Noppadol Maneedang, Leena  Thongmak and Weerawat Limroongreungrat.  (2018). Comparison of physical fitness between professional and university football players. 8 th Institute of Physical Education International Conference     (pp. 639-644). Bangkok: Institute of Physical Education.',
              'year': 2561
            }
          ],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [
            {
              'link': '',
              'name': 'นพดล มณีแดง, นิกร สีแล, ลีนา ทองมาก, ทิชา สังวรกาญจน์ และอภิวัฒน์ จำเดิม. (2565). ผลของความสูงของกล่องพลัยโอต่อตัวแปรทางชีวกลศาสตร์ของการทำแด๊ปจั๊มในนักกีฬามหาวิทยาลัย. การประชุมวิชาการระดับชาติ ครั้งที่ 19 มหาวิทยาลัยเกษตรศาสตร์ วิทยาเขตกำแพงแสน (น.3069 - 3076). มหาวิทยาลัยเกษตรศาสตร์ วิทยาเขตกำแพงแสน.',
              'year': 2566
            }
          ],
          '2567': [
            {
              'link': 'https://so01.tci-thaijo.org/index.php/APST/article/view/270564',
              'name': 'Anupharb Seesangboon, Krit Srirungrangchai, Kayyasit Ritmoon, Natthawee Sriket, Phudis Sriket, Leena Tongmak, Kreangkrai Narktawan, Apiwat Jamderm, Harit Hattha & Anittaya Kanghae. (2567). Shot – term impact of mini – marathon running on alteration of blood lipoproteins. The Asia-Pacific Journal of Science and Technology . 29(5). pp 1-6',
              'year': 2567
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'วิทยาศาสตร์สุขภาพ'
      },

      {
        'faculty': 'วิทยาศาสตร์การกีฬาและสุขภาพ',
        'graduated': {
          'field': [ 'ปรัชญาดุษฎีบัณฑิต (ปร.ด) สาขาวิชาวิทยาศาสตร์การออกกำลังกายและกีฬา', 'วิทยาศาสตรมหาบัณฑิต (วท.ม) สาขาวิชาวิทยาศาสตร์การกีฬา', 'วิทยาศาสตรบัณฑิต (วท.บ) สาขาวิชาวิทยาศาสตร์การกีฬา' ],
          'university': [ 'มหาวิทยาลัยบูรพา', 'มหาวิทยาลัยเกษตรศาสตร์', 'มหาวิทยาลัยมหิดล' ]
        },
        'name': 'ดร.นิกร  สีแล',
        'position': 'ผู้ช่วยศาสตราจารย์',
        'publish': {
          '2560': [
            {
              'link': '',
              'name': 'Nakrob Tongdaeng et al. (2017). A Kinemetial Comparison of Two Difference Preparation Pattern of Pencak Silat Kicking Techniques. International Conference on Sport Management 2017. Vietnam: Ton Due Thong University.',
              'year': 2560
            }
          ],
          '2561': [],
          '2562': [
            {
              'link': '',
              'name': 'Nikorn Selael and et al. (2019). Innovation of Exciting & Challengig Activities for Elderly : Phasel Elderly activities Need and How to Create Exercise Equipment for Them. 9 th Institute of Physical Education International Conference. (หน้า 242-255). Bangkok: Institute of Physical Education.',
              'year': 2562
            }
          ],
          '2563': [],
          '2564': [
            {
              'link': '',
              'name': 'Praphinvit Pokard, et al. The Effect of Augmented Reality Technology on Mobile Application in Physical Fitness for Falls Prevention in Elderly. The 11 th International conference of sports and exercise science (ICSES 2021) ',
              'year': 2564
            }
          ],
          '2565': [],
          '2566': [
            {
              'link': '',
              'name': 'นพดล มณีแดง, นิกร สีแล, ลีนา ทองมาก, ทิชา สังวรกาญจน์ และอภิวัฒน์ จำเดิม. (2565). ผลของความสูงของกล่องพลัยโอต่อตัวแปรทางชีวกลศาสตร์ของการทำแด๊ปจั๊มในนักกีฬามหาวิทยาลัย. การประชุมวิชาการระดับชาติ ครั้งที่ 19 มหาวิทยาลัยเกษตรศาสตร์ วิทยาเขตกำแพงแสน (น.3069 - 3076). มหาวิทยาลัยเกษตรศาสตร์ วิทยาเขตกำแพงแสน.',
              'year': 2566
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'วิทยาศาสตร์การกีฬา,สมรรถภาพทางกาย'
      },

      {
        'faculty': 'คณะวิทยาศาสตร์การกีฬาและสุขภาพ',
        'graduated': {
          'field': [ 'ปรัชญาดุษฎีบัณฑิต (ปร.ด) สาขาวิชาวิทยาศาสตร์การออกกำลังกายและกีฬา', 'วิทยาศาสตรมหาบัณฑิต (วท.ม) สาขาวิชาวิทยาศาสตร์การกีฬา', 'วิทยาศาสตรบัณฑิต (วท.บ) สาขาวิชาวิทยาศาสตร์การกีฬา' ],
          'university': [ 'มหาวิทยาลัยศรีนครินทรวิโรฒ', 'มหาวิทยาลัยศรีนครินทรวิโรฒ', 'มหาวิทยาลัยศรีนครินทรวิโรฒ' ]
        },
        'name': 'ดร.เกรียงไกร  นาคเทวัญ',
        'position': '',
        'publish': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [],
          '2567': [
            {
              'link': 'https://so01.tci-thaijo.org/index.php/APST/article/view/270564',
              'name': 'Anupharb Seesangboon, Krit Srirungrangchai, Kayyasit Ritmoon, Natthawee Sriket, Phudis Sriket, Leena Tongmak, Kreangkrai Narktawan, Apiwat Jamderm, Harit Hattha & Anittaya Kanghae. (2567). Shot – term impact of mini – marathon running on alteration of blood lipoproteins. The Asia-Pacific Journal of Science and Technology . 29(5). pp 1-6',
              'year': 2567
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'ผู้ฝึกกีฬา, วิทยาศาสตร์การกีฬา, นักจิตวิทยาการกีฬา'
      },
      {
        'faculty': 'คณะวิทยาศาสตร์การกีฬาและสุขภาพ',
        'graduated': {
          'field': [ 'การศึกษามหาบัณฑิต (กศ.ม) สาขาวิชาชีววิทยา', 'ครุศาสตรบัณฑิต (ค.บ) สาขาวิชาวิทยาศาสตร์ทั่วไป' ],
          'university': [ 'มหาวิทยาลัยศรีนครินทรวิโรฒ', 'วิทยาลัยครูนครสวรรค์' ]
        },
        'name': 'นายโรจรวี  ชัยรัตน์',
        'position': '',
        'publish': {
          '2560': [],
          '2561': [
            {
              'link': '',
              'name': 'Apivat Jamderm and Rojrawee Chairat. (2018). Effects of core muscle strength training on balance and accuracy in shooting. 8 th Institute of Physical Education International Conference (pp. 645-651). Bangkok: Institute of Physical Education.',
              'year': 2561
            }
          ],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [],
          '2567': [
            {
              'link': 'https://so03.tci-thaijo.org/index.php/KRUjournal/article/view/274471',
              'name': 'กฤตยา ศุภมิตร, ทัตพิชา พงษ์ศิริ, พัชรี ทองคำพานิช, ภูดิส ศรีเกตุ, โรจน์รวี ชัยรัตน์, สุรัตนา ทองศรี, ณธพล ทองธนภัทร, พีระพงศ์ หนูพยันต์ และวุฒิชัย อ่อนสด. (2567). ความคิดเห็นของผู้มีส่วนได้ส่วนเสียต่อการพัฒนาหลักสูตรวิทยาศาสตรบัณฑิตสาขาวิทยาศาสาตร์การกีฬาและการออกกำลังกาย. วารสารวิชาการ มหาวิทยาลัยราชภัฏกาญจนบุรี. 13(1), หน้า 87 - 98. ',
              'year': 2567
            }
          ]
        },
        'research': {
          '2560': [
            {
              'budget': '50000',
              'doc': 'https://drive.google.com/file/d/1i43YwY0jRKpG_VCbRm0k6bALqLLGItti/view?usp=sharing',
              'name': 'อภิวัฒน์ จำเดิม และโรจน์รวี ชัยรัตน์. (2560). ผลของการฝึกความแข็งแรงกล้ามเนื้อแกนกลางลำตัวที่มีต่อการทรงตัวและความแม่นยำในการยิงลูกเปตอง. ชุมพร: สถาบันการพลศึกษา วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยร่วม',
              'year': 2560
            }
          ],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'ชีววิทยา,วิทยาศาสตร์ทั่วไป'
      },
      {
        'faculty': 'คณะวิทยาศาสตร์การกีฬาและสุขภาพ',
        'graduated': {
          'field': [ 'วิทยาศาสตรมหาบัณฑิต (วท.ม) สาขาวิชาวิทยาศาสตร์การกีฬา', 'วิทยาศาสตรบัณฑิต (วท.บ) สาขาวิชาวิทยาศาสตร์การกีฬา' ],
          'university': [ 'มหาวิทยาลัยศรีนครินทรวิโรฒ', 'มหาวิทยาลัยศรีนครินทรวิโรฒ' ]
        },
        'name': 'นายอภิวัฒน์  จำเดิม',
        'position': '',
        'publish': {
          '2560': [],
          '2561': [
            {
              'link': '',
              'name': 'Apivat Jamderm and Rojrawee Chairat. (2018). Effects of core muscle strength training on balance and accuracy in shooting. 8 th Institute of Physical Education International Conference (pp. 645-651). Bangkok: Institute of Physical Education.',
              'year': 2561
            },
            {
              'link': '',
              'name': 'Tichar Sungworakan and Apivat Jamderm. (2018). Motivation for Ecetcise of People in Chumphon Province. 8 th Institute of Physical Education International Conference (pp. 674-680). Bangkok: Institute of Physical Education.',
              'year': 2561
            }
          ],
          '2562': [
            {
              'link': '',
              'name': 'Nikorn Selael and et al. (2019). Innovation of Exciting & Challengig Activities for Elderly : Phasel Elderly activities Need and How to Create Exercise Equipment for Them. 9 th Institute of Physical Education International Conference. (หน้า 242-255). Bangkok: Institute of Physical Education.',
              'year': 2562
            }
          ],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [
            {
              'link': '',
              'name': 'นพดล มณีแดง, นิกร สีแล, ลีนา ทองมาก, ทิชา สังวรกาญจน์ และอภิวัฒน์ จำเดิม. (2565). ผลของความสูงของกล่องพลัยโอต่อตัวแปรทางชีวกลศาสตร์ของการทำแด๊ปจั๊มในนักกีฬามหาวิทยาลัย. การประชุมวิชาการระดับชาติ ครั้งที่ 19 มหาวิทยาลัยเกษตรศาสตร์ วิทยาเขตกำแพงแสน (น.3069 - 3076). มหาวิทยาลัยเกษตรศาสตร์ วิทยาเขตกำแพงแสน.',
              'year': 2566
            }
          ],
          '2567': [
            {
              'link': 'https://so01.tci-thaijo.org/index.php/APST/article/view/270564',
              'name': 'Anupharb Seesangboon, Krit Srirungrangchai, Kayyasit Ritmoon, Natthawee Sriket, Phudis Sriket, Leena Tongmak, Kreangkrai Narktawan, Apiwat Jamderm, Harit Hattha & Anittaya Kanghae. (2567). Shot – term impact of mini – marathon running on alteration of blood lipoproteins. The Asia-Pacific Journal of Science and Technology . 29(5). pp 1-6',
              'year': 2567
            }
          ]
        },
        'research': {
          '2560': [
            {
              'budget': '50000',
              'doc': 'https://drive.google.com/file/d/1i43YwY0jRKpG_VCbRm0k6bALqLLGItti/view?usp=sharing',
              'name': 'อภิวัฒน์ จำเดิม และโรจน์รวี ชัยรัตน์. (2560). ผลของการฝึกความแข็งแรงกล้ามเนื้อแกนกลางลำตัวที่มีต่อการทรงตัวและความแม่นยำในการยิงลูกเปตอง. ชุมพร: สถาบันการพลศึกษา วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยหลัก',
              'year': 2560
            }
          ],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'ผู้ฝึกสอนกีฬา,วิทยาศาสตร์การกีฬา'
      },
      {
        'faculty': 'คณะวิทยาศาสตร์การกีฬาและสุขภาพ',
        'graduated': {
          'field': [ 'วิทยาศาสตรมหาบัณฑิต (วท.ม) สาขาวิชาวิทยาศาสตร์การกีฬา', 'วิทยาศาสตรบัณฑิต (วท.บ) สาขาวิชาวิทยาศาสตร์การกีฬา' ],
          'university': [ 'จุฬาลงกรณ์มหาวิทยาลัย', 'มหาวิทยาลัยศรีนครินทรวิโรฒ' ]
        },
        'name': 'นายทิชา  สังวรกาญจน์',
        'position': '',
        'publish': {
          '2560': [],
          '2561': [],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [
            {
              'link': '',
              'name': 'นพดล มณีแดง, นิกร สีแล, ลีนา ทองมาก, ทิชา สังวรกาญจน์ และอภิวัฒน์ จำเดิม. (2565). ผลของความสูงของกล่องพลัยโอต่อตัวแปรทางชีวกลศาสตร์ของการทำแด๊ปจั๊มในนักกีฬามหาวิทยาลัย. การประชุมวิชาการระดับชาติ ครั้งที่ 19 มหาวิทยาลัยเกษตรศาสตร์ วิทยาเขตกำแพงแสน (น.3069 - 3076). มหาวิทยาลัยเกษตรศาสตร์ วิทยาเขตกำแพงแสน.',
              'year': 2566
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'การออกกำลังกายเพื่อสุขภาพ'
      },
      {
        'faculty': 'คณะวิทยาศาสตร์การกีฬาและสุขภาพ',
        'graduated': {
          'field': [ 'วิทยาศาสตรมหาบัณฑิต (วท.ม) สาขาวิชาวิทยาศาสตร์การกีฬา', 'วิทยาศาสตรบัณฑิต (วท.บ) สาขาวิชาวิทยาศาสตร์การกีฬา' ],
          'university': [ 'มหาวิทยาลัยมหิดล', 'มหาวิทยาลัยมหิดล' ]
        },
        'name': 'นายนพดล  มณีแดง',
        'position': '',
        'publish': {
          '2560': [
            {
              'link': '',
              'name': 'Kusuma Buayai, et al. (2017). Physical Fitness Test Of The Sport Players of Physical Education Institute Chiang Mai Campus Participating In The 41 st Physical Education Institute Games. 7 th Institute of Physical Education International Conference (pp.333-339). Bangkok: Institute of Physical Education.              ',
              'year': 2560
            }
          ],
          '2561': [
            {
              'link': '',
              'name': 'Noppadol Maneedang, Leena  Thongmak and Weerawat Limroongreungrat.  (2018). Comparison of physical fitness between professional and university football players. 8 th Institute of Physical Education International Conference (pp. 639-644). Bangkok: Institute of Physical Education.',
              'year': 2561
            }
          ],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [
            {
              'link': '',
              'name': 'นพดล มณีแดง, นิกร สีแล, ลีนา ทองมาก, ทิชา สังวรกาญจน์ และอภิวัฒน์ จำเดิม. (2565). ผลของความสูงของกล่องพลัยโอต่อตัวแปรทางชีวกลศาสตร์ของการทำแด๊ปจั๊มในนักกีฬามหาวิทยาลัย. การประชุมวิชาการระดับชาติ ครั้งที่ 19 มหาวิทยาลัยเกษตรศาสตร์ วิทยาเขตกำแพงแสน (น.3069 - 3076). มหาวิทยาลัยเกษตรศาสตร์ วิทยาเขตกำแพงแสน.',
              'year': 2566
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'Sports Biomechanics,วิทยาศาสตร์การกีฬา'
      },
      {
        'faculty': 'คณะวิทยาศาสตร์การกีฬาและสุขภาพ',
        'graduated': {
          'field': [ 'วิทยาศาสตรมหาบัณฑิต (วท.ม.) สาขาคณิตศาสตร์ประยุกต์', 'วิทยาศาสตรบัณฑิต (วท.บ.) สาขาคณิตศาสตร์' ],
          'university': [ 'มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี', 'มหาวิทยาลัยศรีนครินทรวิโรฒ' ]
        },
        'name': 'นายวุฒิชัย  อ่อนสด',
        'position': '',
        'publish': {
          '2560': [],
          '2561': [],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [],
          '2567': [
            {
              'link': 'https://so03.tci-thaijo.org/index.php/KRUjournal/article/view/274471',
              'name': 'กฤตยา ศุภมิตร, ทัตพิชา พงษ์ศิริ, พัชรี ทองคำพานิช, ภูดิส ศรีเกตุ, โรจน์รวี ชัยรัตน์, สุรัตนา ทองศรี, ณธพล ทองธนภัทร, พีระพงศ์ หนูพยันต์ และวุฒิชัย อ่อนสด. (2567). ความคิดเห็นของผู้มีส่วนได้ส่วนเสียต่อการพัฒนาหลักสูตรวิทยาศาสตรบัณฑิตสาขาวิทยาศาสาตร์การกีฬาและการออกกำลังกาย. วารสารวิชาการ มหาวิทยาลัยราชภัฏกาญจนบุรี. 13(1), หน้า 87 - 98. ',
              'year': 2567
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'คณิตศาสตร์, สถิติ'
      },
      {
        'faculty': 'คณะวิทยาศาสตร์การกีฬาและสุขภาพ',
        'graduated': {
          'field': [ 'วิทยาศาสตรมหาบัณฑิต (วท.ม.) สาขาวิทยาศาสตร์การกีฬา', 'วิทยาศาสตรบัณฑิต (วท.บ.) สาขาวิทยาศาสตร์การกีฬา' ],
          'university': [ 'มหาวิทยาลัยเชียงใหม่', 'สถาบันการพลศึกษา วิทยาเขตเชียงใหม่' ]
        },
        'name': 'นายณัฐพล ประภารัตน์',
        'position': '',
        'publish': {
          '2560': [],
          '2561': [],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [],
          '2567': [],
          '2568': [],
          '2569': [
            {
              'link': '',
              'name': 'ณัฐพล ประภารัตน์, พัชรี ย่ำเที่ยง, และปริศนา ดุจจานุทัศน์. (2569). ผลของโปรแกรมการฝึกแบบสถานีร่วมกับ กิจกรรมนันทนาการที่ส่งผลต่อความแข็งแรงของกล้ามเนื้อแกนกลางลำตัวและความแข็งแรงของ กล้ามเนื้อขาของนักศึกษา มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตเพชรบูรณ์. วารสารสุขศึกษา พลศึกษาและนันทนาการ, 52(2).',
              'year': 2569
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [],
          '2567': [],
          '2568': [],
          '2569': []
        },
        'specialization': 'วิทยาศาสตร์การกีฬา, ลีลาศ'
      },
      {
        'faculty': 'คณะศิลปศาสตร์',
        'graduated': {
          'field': [ 'ศิลปศาสตรมหาบัณฑิต (ศศ.ม) สาขาวิชายุทธศาสตร์การพัฒนา', 'ครุศาสตรบัณฑิต (ค.บ) สาขาวิชาธุรกิจศึกษา', '', '' ],
          'university': [ 'มหาวิทยาลัยราชภัฏสุราษฏร์ธานี', 'สถาบันราชภัฏสุราษฏร์ธานี' ]
        },
        'name': 'นางสาววนิดา  พูลนวล',
        'position': '',
        'publish': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [
            {
              'link': '',
              'name': 'อมรินทร์ หัตถกิจ, จิรยุทธ คงพยัคฆ์, ทัศนียา ถึงอินทร์, จิราภรณ์ ขาวศรี, อัศวิน มณีอินทร์ และ วนิดา พูลนวล. (2566). การประเมินความพึงพอใจของประชาชนในเขตเทศบาลเมืองชุมพรที่มีต่อการจัดกิจกรรมโปรแกรมลีลาศกับเกมนันทนาการ และกิจกรรมโปรแกรมลีลาศกับการร้องเพลงคาราโอเกะ : กรณีศึกษาผู้สูงอายุชมรมลีลาศจังหวัดชุมพร. ใน พราม อินพรม และธีรนันท์ ตันพานิช (บ.ก.). การประชุมวิชาการแห่งชาติ สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย (น. 112 - 123). สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย.',
              'year': 2566
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'ยุทธศาสตร์การพัฒนา,เศรษฐกิจพอเพียง'
      },
      {
        'faculty': 'คณะศิลปศาสตร์',
        'graduated': {
          'field': [ 'Doctor of Philosophy (Ph.D) (Education)', 'ครุศาสตรมหาบัณฑิต (ค.ม.) สาขาพลศึกษา', 'การศึกษาบัณฑิต (กศ.บ) สาขาพลศึกษา' ],
          'university': [ 'Sardarpatel University', 'จุฬาลงกรณ์มหาวิทยาลัย', 'มหาวิทยาลัยศรีนครินทรวิโรฒ พลศึกษา' ]
        },
        'name': 'ดร.ศักดิ์  อินพิรุด',
        'position': 'ผู้ช่วยศาสตราจารย์',
        'publish': {
          '2560': [
            {
              'link': '',
              'name': 'Asawin Maneein, et al.  (2017). The Influential Factors On Motivation In Walk Rally Participation of Undergraduate Students at Institute of Physical Education, Chumphon. 7 th Institute of Physical Education International Conference (pp. 211-217). Bangkok: Institute of Physical Education.',
              'year': 2560
            }
          ],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': [
            {
              'budget': '50000',
              'doc': 'https://drive.google.com/file/d/1TZyYFjEm6oGY5bKFKLR6vyb_1f_RdsHS/view?usp=sharing',
              'name': 'การสำรวจลีลาชีวิตเกี่ยวกับการเข้าร่วมกิจกรรมนันทนาการเพื่อพัฒนาคุณภาพของผู้สูงอายุภาคใต้: กรณีศึกษากลุ่มภาคใต้ตอนบน',
              'role': 'ผู้วิจัยหลัก',
              'year': 2562
            }
          ]
        },
        'specialization': 'นันทนาการ,ลีลาศ'
      },
      {
        'faculty': 'คณะศิลปศาสตร์',
        'graduated': {
          'field': [ 'ศิลปศาสตรมหาบัณฑิต (ศศ.ม) สาขาวิชาบรรณารักษศาสตร์และสารนิเทศศาสตร์', 'อักษรศาสตรบัณฑิต (อ.บ) สาขาวิชาบรรณารักษศาสตร์' ],
          'university': [ 'มหาวิทยาลัยธรรมศาสตร์', 'มหาวิทยาลัยศิลปากร' ]
        },
        'name': 'นางสาวอุไรวรรณ วรกุลรังสรรค์',
        'position': 'ผู้ช่วยศาสตราจารย์',
        'publish': {
          '2560': [],
          '2561': [
            {
              'link': '',
              'name': 'อุไรวรรณ วรกุลรังสรรค์. (2561). ผลการเรียนรู้ด้วยบทเรียนผ่านเว็บรายวิชาสารสนเทศเพื่อการศึกษาค้นคว้า. การประชุมวิชาการระดับชาติและนานาชาติสหวิทยาการสร้างสรรค์เพื่อการพัฒนาที่ยั่งยืนครั้งที่ 3 บัณฑิตวิทยาลัย มหาวิทยาลัยศิลปากร (หน้า H69-H79). กรุงเทพฯ: มหาวิทยาลัยศิลปากร.',
              'year': 2561
            }
          ],
          '2562': [
            {
              'link': '',
              'name': 'อุไรวรรณ วรกุลรังสรรค์. (2562). การประเมินศักยภาพและความคาดหวังในการจัดตั้งคลังปํญญาของสถาบันการพลศึกษา. ชุมพร: สถาบันการพลศึกษา วิทยาเขตชุมพร.',
              'year': 2562
            },
            {
              'link': '',
              'name': 'อุไรวรรณ วรกุลรังสรรค์. (2562). การใช้สารสนเทศเพื่องานวิจัยของบุคลากรในสังกัดสถาบันการพลศึกษา. การประชุมวิชาการระดับชาติมหาวิทยาลัยทักษิณ ครั้งที่ 29 ประจำปี 2562 วิจัยและนวัตกรรมเพื่อการพัฒนาที่ยั่งยืน Research and Innovation for Sustsinability Development (หน้า 752-759). สงขลา: มหาวิทยาลัยทักษิณ.',
              'year': 2562
            },
            {
              'link': '',
              'name': 'วัชชิรา ศักดิ์สนิท และคณะ. (2562). ปัจจัยที่มีผลต่อพฤติกรรมสุขภาพ 3อ 2ส ของผู้สูงอายุ: กรณีศึกษาผู้สูงอายุ ตำบลนาชะอัง อำเภอเมือง จังหวัดชุมพร. การประชุมวิชาการระดับชาติ มหาวิทยาลัยราชภัฏภูเก็ต ครั้งที่ 12 : 2562 "การวิจัยสหวิทยาการบนพื้นฐานยุค 5.0" (หน้า 156-167). ภูเก็ต: สถาบันวิจัยและพัฒนา มหาวิทยาลัยราชภัฏภูเก็ต.',
              'year': 2562
            }
          ],
          '2563': [
            {
              'link': 'https://drive.google.com/file/d/1cuhIK1QIWUNID-gw8WP_gQ0qWd_5lfJx/view?usp=sharing',
              'name': 'อุไรวรรณ วรกุลรังสรรค์, ธีรดา  ศิริภิรมย์ และชลธิชาสิ้วอินทร์. (2563). การประเมินศักยภาพและความคาดหวังในการจัดตั้งคลังปัญญาของสถาบันการพลศึกษา. การประชุมวิชาการระดับชาติพิบูลสงครามวิจัย ครั้งที่ 6 ประจำปี พ.ศ.2563 (หน้า 536-545). พิษณุโลก: มหาวิทยาลัยราชภัฏพิบูลสงคราม.',
              'year': 2563
            }
          ],
          '2564': [
            {
              'link': '',
              'name': 'อุไรวรรณ วรกุลรังสรรค์ และชลธิชาสิ้วอินทร์. (2564). การวิเคราะห์เนื้อหาวิทยานิพนธ์ มหาวิทยาลัยการกีฬาแห่งชาติ. ประชุมวิชาการระดับชาติมหาวิทยาลัยราชภัฏกลุ่มศรีอยุธยา ครั้งที่ 11 “งานวิจัยและนวัตกรรมเพื่อการพัฒนาชุมชนเชิงพื้นที่”(รูปแบบออนไลน์).',
              'year': 2563
            },
            {
              'link': '',
              'name': 'จิรายุทธ  คงพยัคฆ์, อุไรวรรณ  วรกุลรังสรรค์ และธีรดา  ศิริภิรมย์. (2564). ปัจจัยการมีส่วนร่วมทางการเมืองของนักศึกษามหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตภาคใต้. การประชุมวิชาการระดับชาติ สาขามนุษยศาสตร์และสังคมศาสตร์ ครั้งที่ 5 ประจำปี 2564 (รูปแบบออนไลน์.',
              'year': 2563
            }
          ],
          '2565': [],
          '2566': [
            {
              'link': '',
              'name': 'อุไรวรรณ วรกุลรังสรรค์, ธีรดา ศิริภิรมย์ และณัฐสุดา เพชรวงศ์. (2565). การดำเนินงานเพื่อเชื่อมโยงสู่ฐานข้อมูล TDC ของมหาวิทยาลัยการกีฬาแห่งชาติ. รายงานสืบเนื่องจากงานประชุมวิชาการระดับชาตินนทรีอีสาน ครั้งที่ 10 ประจำปี 2565., (น.1443 – 1450). มหาวิทยาลัยเกษตรศาสตร์ วิทยาเขตเฉลิมพระเกียรติ จังหวัดสกลนคร.',
              'year': 2565
            }
          ]
        },
        'research': {
          '2560': [
            {
              'budget': '50000',
              'doc': '',
              'name': 'อุไรวรรณ วรกุลรังสรรค์. (2560). ผลการเรียนรู้ด้วยบทเรียนผ่านเว็บรายวิชาสารสนเทศเพื่อการศึกษาค้นคว้า. ชุมพร: สถาบันการพลศึกษา วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยหลัก',
              'year': 2560
            }
          ],
          '2561': [
            {
              'budget': '50000',
              'doc': 'https://drive.google.com/file/d/1SiuqD7zAb7U6UVAh6xgWuaqE07BN0LBM/view?usp=sharing',
              'name': 'อุไรวรรณ วรกุลรังสรรค์. (2561). การใช้สารสนเทศเพื่องานวิจัยของบุคลากรในสังกัดสถาบันการพลศึกษา. ชุมพร: สถาบันการพลศึกษา วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยหลัก',
              'year': 2561
            }
          ],
          '2562': [
            {
              'budget': '50000',
              'doc': 'https://drive.google.com/file/d/1yNwqEa275iiPJkoT8ycFG7YeeGI2ZaDi/view?usp=sharing',
              'name': 'อุไรวรรณ วรกุลรังสรรค์. (2562). การประเมินศักยภาพและความคาดหวังในการจัดตั้งคลังปัญญาของสถาบันการพลศึกษา. ชุมพร: มหาวิทยาลัยการกีฬาแห่งชา่ติ วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยหลัก',
              'year': 2562
            }
          ],
          '2563': [
            {
              'budget': '50000',
              'doc': '',
              'name': 'อุไรวรรณ วรกุลรังสรรค์. (2563).การวิเคราะห์เนื้อหาวิทยานิพนธ์ มหาวิทยาลัยการกีฬาแห่งชาติ. ชุมพร: มหาวิทยาลัยการกีฬาแห่งชา่ติ วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยหลัก',
              'year': 2563
            }
          ],
          '2564': [
            {
              'budget': '50000',
              'doc': 'https://drive.google.com/file/d/1rdmwRGAgTeUBMDHQZnRXtn_5mWbSR_6I/view?usp=sharing',
              'name': 'อุไรวรรณ วรกุลรังสรรค์. (2564).การดำเนินงานเพื่อเชื่อมโยงสู่ฐานข้อมูล TDC ของมหาวิทยาลัยการกีฬาแห่งชาติ. ชุมพร: มหาวิทยาลัยการกีฬาแห่งชา่ติ วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยหลัก',
              'year': 2564
            }
          ],
          '2565': []
        },
        'specialization': 'บรรณารักษ์ศาสตร์,บรรณารักษ์ศาสตร์และสารสนเทศศาสตร์'
      },
      {
        'faculty': 'คณะศิลปศาสตร์',
        'graduated': {
          'field': [ 'บริหารธุรกิจมหาบัณฑิต (บธ.ม) สาขาวิชาการจัดการทั่วไป', 'บริหารธุรกิจบัณฑิต (บช.บ) สาขาวิชาบัญชี' ],
          'university': [ 'มหาวิทยาลัยรามคำแหง', 'มหาวิทยาลัยสุโขทัยธรรมาธิราช' ]
        },
        'name': 'นางนวรัตน์  เจริญสุข',
        'position': 'ผู้ช่วยศาสตราจารย์',
        'publish': {
          '2560': [],
          '2561': [
            {
              'link': '',
              'name': 'Nawarat Jarernsuk. (2018). Knowledge and Attitude of Undergraduates Toward Human Resourcemanagement : Case Study of Instityte of Physical Educatuon in Southern Campus. 8 th Institute of Physical Education International Conference (pp.1076-1083). Bangkok: Institute of Physical Education.',
              'year': 2561
            }
          ],
          '2562': [],
          '2563': [
            {
              'link': 'https://drive.google.com/file/d/1r3Ohgfnhi5EfISc11QbnjK-bIbYxV8yR/view?usp=sharing',
              'name': 'นวรัตน์ เจริญสุข. (2563). ความต้องการของผู้ประกอบการในการพัฒนาทรัพยากรมนุษย์ด้านการท่องเที่ยว กรณีศึกษา : สถานประกอบการในจังหวดัชุมพร จังหวัดระนอง และจังหวัดสุราษฎร์ธานี. การประชุมวิชาการระดับชาติ "มศว วิจัย" ครั้งที่ 13 (หน้า 1118-1128). กรุงเทพมหานคร: มหาวิทยาลัยศรีนครินทรวิโรฒ.              ',
              'year': 2563
            }
          ],
          '2564': [],
          '2565': []
        },
        'research': {
          '2560': [
            {
              'budget': '50000',
              'doc': 'https://drive.google.com/file/d/12QOE07nuYLzRfNtkXuhLBxGRgqeiKSjD/view?usp=sharing',
              'name': 'นวรัตน์ เจริญสุข. (2560). คุณลักษณะอันพึงประสงค์ของบุคลากรสายสนับสนุนต่อการให้บริการของส่วนงานที่เกี่ยวข้องสถาบันการพลศึกษา. ชุมพร: สถาบันการพลศึกษา วิทยาเขตชุมพร.',
              'role': 'ผู้วจัยหลัก',
              'year': 2560
            }
          ],
          '2561': [
            {
              'budget': '50000',
              'doc': 'https://drive.google.com/file/d/1c-MTqwyBqbJbKztUbFR3uBDxzG-vjJXK/view?usp=sharing',
              'name': 'นวรัตน์ เจริญสุข. (2561). คุณลักษณะบัณฑิตที่พึงประสงค์สำหรับสถานที่ประกอบการ กรณีศึกษาบัณฑิตสาขานันทนาการและการท่องเที่ยว    คณะศิลปศาสตร์ สถาบันการพลศึกษา วิทยาเขตชุมพร. ชุมพร: สถาบันการพลศึกษา วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยหลัก',
              'year': 2561
            }
          ],
          '2562': [
            {
              'budget': '50000',
              'doc': '',
              'name': 'นวรัตน์ เจริญสุข. (2562). ความต้องการของสถานประกอบการในการพัฒนาทรัพยากรมนุษย์ด้านการท่องเที่ยว กรณ๊ศึกษา สถานประกอบการในจังหวัดชุมพร จังหวัดระนอง และจังหวัดสุราษฎร์ธานี. ชุมพร: มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยหลัก',
              'year': 2562
            }
          ],
          '2563': [],
          '2564': [
            {
              'budget': '50000',
              'doc': 'https://drive.google.com/file/d/1sQ-LXbeBul6VMkcZ5zmOftDCpAEWrL6g/view?usp=sharing',
              'name': 'นวรัตน์ เจริญสุข. (2564).การพัฒนาศักยภาพทรัพยากรมนุษย์ของธุรกิจท่องเที่ยวใน 5 จังหวัดท่องเที่ยวสำคัญของภาคใต้ที่ได้รับผลกระทบจากการแพร่ระบาดของ COVID-19. ชุมพร: มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยหลัก',
              'year': 2564
            }
          ],
          '2565': []
        },
        'specialization': 'การจัดการทรัพยากรมนุษย์'
      },
      {
        'faculty': 'คณะศิลปศาสตร์',
        'graduated': {
          'field': [ 'ศึกษาศาสตรมหาบัณฑิต (ศษ.ม) สาขาวิชาการบริหารการศึกษา', 'ศิลปศาสตรบัณฑิต (ศศ.บ) สาขาวิชาการจัดการทั่วไป' ],
          'university': [ 'มหาวิทยาลัยรามคำแหง', 'วิทยาลัยครูสุราษฏร์ธานี' ]
        },
        'name': 'นางสาวภควรรณ  ชวาสิทธิ์',
        'position': '',
        'publish': {
          '2560': [],
          '2561': [
            {
              'link': '',
              'name': 'Phakkhawan Chawasit. (2018). Behabvior Tousists Thailand on Tourist Sites in Chumphon.   8 th Institute of Physical Education International Conference (pp. 909-914). Bangkok: Institute of Physical Education',
              'year': 2561
            }
          ],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'research': {
          '2560': [],
          '2561': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'การบริหารการศึกษา,การท่องเที่ยว'
      },
      {
        'faculty': 'คณะศิลปศาสตร์',
        'graduated': {
          'field': [ 'บริหารธุรกิจบัณฑิต (บธ.ม) สาขาวิชาการจัดการทั่วไป', 'บัญชีบัณฑิต (บช.บ) สาขาวิชาการบัญชี' ],
          'university': [ 'มหาวิทยาลัยรามคำแหง', 'มหาวิทยาลัยศรีปทุม' ]
        },
        'name': 'นางสาวเป็นหนึ่ง  เกิดดำ',
        'position': '',
        'publish': {
          '2560': [],
          '2561': [],
          '2562': [
            {
              'link': '',
              'name': 'วัชชิรา ศักดิ์สนิท และคณะ. (2562). ปัจจัยที่มีผลต่อพฤติกรรมสุขภาพ 3อ 2ส ของผู้สูงอายุ: กรณีศึกษาผู้สูงอายุ ตำบลนาชะอัง อำเภอเมือง จังหวัดชุมพร. การประชุมวิชาการระดับชาติ มหาวิทยาลัยราชภัฏภูเก็ต ครั้งที่ 12 : 2562 "การวิจัยสหวิทยาการบนพื้นฐานยุค 5.0" (หน้า 156-167). ภูเก็ต: สถาบันวิจัยและพัฒนา มหาวิทยาลัยราชภัฏภูเก็ต.              ',
              'year': 2562
            }
          ],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [],
          '2567': [],
          '2568': [
            {
              'link': 'https://drive.google.com/file/d/1MYQhfcDOIYtvaotTmZFg2v1etOliIWPT/view',
              'name': 'ทัศนียา ถึงอินทร์ และเป็นหนึ่ง เกิดดำ. (2568). พฤติกรรมและแรงจูงใจการท่องเที่ยวเชิงสุขภาพของผู้สูงอายุจังหวัดชุมพร. ใน นิตย์ ศรีแสงเดือน (บ.ก.).  การประชุมวิชาการระดับชาติ ครั้งที่ 15 ประจำปีการศึกษา 2567 หัวข้อ “การศึกษาในยุค AI” โอกาสหรือวิกฤต ?. (น.130 – น.137). วิทยาลัยเทคโนโลยีภาคใต้. ',
              'year': 2568
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'การจัดการ'
      },
      {
        'faculty': 'คณะศิลปศาสตร์',
        'graduated': {
          'field': [ 'รัฐประศาสนศาสตรมหาบัณฑิต (รป.ม) สาขาวิชาการปกครองท้องถิ่น', 'ศิลปศาสตรบัณฑิต (ศศ.บ) สาขาวิชาการพัฒนาชุมชน' ],
          'university': [ 'มหาวิทยาลัยราชภัฏสุราษฏร์ธานี', 'สถาบันราชภัฏสุราษฏร์ธานี' ]
        },
        'name': 'นายจิรยุทธ์  คงพยัคฆ์',
        'position': '',
        'publish': {
          '2560': [],
          '2561': [],
          '2563': [],
          '2564': [
            {
              'link': '',
              'name': 'จิรายุทธ  คงพยัคฆ์, อุไรวรรณ  วรกุลรังสรรค์ และธีรดา  ศิริภิรมย์. (2564). ปัจจัยการมีส่วนร่วมทางการเมืองของนักศึกษามหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตภาคใต้. การประชุมวิชาการระดับชาติ สาขามนุษยศาสตร์และสังคมศาสตร์ ครั้งที่ 5 ประจำปี 2564 (รูปแบบออนไลน์.',
              'year': 2563
            }
          ],
          '2565': [],
          '2566': [
            {
              'link': '',
              'name': 'อมรินทร์ หัตถกิจ, จิรยุทธ คงพยัคฆ์, ทัศนียา ถึงอินทร์, จิราภรณ์ ขาวศรี, อัศวิน มณีอินทร์ และ วนิดา พูลนวล. (2566). การประเมินความพึงพอใจของประชาชนในเขตเทศบาลเมืองชุมพรที่มีต่อการจัดกิจกรรมโปรแกรมลีลาศกับเกมนันทนาการ และกิจกรรมโปรแกรมลีลาศกับการร้องเพลงคาราโอเกะ : กรณีศึกษาผู้สูงอายุชมรมลีลาศจังหวัดชุมพร. ใน พราม อินพรม และธีรนันท์ ตันพานิช (บ.ก.). การประชุมวิชาการแห่งชาติ สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย (น. 112 - 123). สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย.',
              'year': 2566
            }
          ],
          '2567': [],
          '2568': [
            {
              'link': 'https://drive.google.com/file/d/1KRCt8I558DCdifQ3QtD0IREYPffjM9j7/view',
              'name': 'จิราภรณ์ ขาวศรี, ทัศนียา ถึงอินทร์, จิรยุทธ คงพยัคฆ์, อมรินทร์ หัตถกิจ และอัศวิน มณีอินทร์.  (2568). ความคิดเห็นต่อหลักสูตรศิลปศาสตรบัณฑิต สาขาการท่องเที่ยวและนันทนาการ มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร. ใน นิตย์ ศรีแสงเดือน (บ.ก.). การประชุมวิชาการระดับชาติ ครั้งที่ 15 ประจำปีการศึกษา 2567 หัวข้อ “การศึกษาในยุค AI” โอกาสหรือวิกฤต ?. (น.254 – น.264). วิทยาลัยเทคโนโลยีภาคใต้. ',
              'year': 2568
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [
            {
              'budget': '50000',
              'doc': '',
              'name': 'นายจิรยุทธ  คงพยัคฆ์. (2560). ปัจจัยที่มีผลต่อการมีส่วนร่วมทางการเมืองของนักศึกษามหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตภาคใต้. ชุมพร: มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยหลัก',
              'year': 2560
            }
          ],
          '2564': [],
          '2565': []
        },
        'specialization': 'การปกครองท้องถิ่น'
      },
      {
        'faculty': 'คณะศิลปศาสตร์',
        'graduated': {
          'field': [ 'ศิลปศาสตรมหาบัณฑิต (ศศ.ม) สาขาวิชาภาษาอังกฤษเพื่อการสื่อสารทางธุรกิจ', 'สังคมศาสตรบัณฑิต (ศศ.บ) สาขาวิชานิเทศศาสตร์' ],
          'university': [ 'มหาวิทยาลัยราชภัฏจันทร์เกษม', 'มหาวิทยาลัยวลัยลักษณ์' ]
        },
        'name': 'นางสาวธีรดา  ศิริภิรมย์',
        'position': '',
        'publish': {
          '2560': [
            {
              'link': '',
              'name': 'Asawin Maneein, et al.  (2017). The Influential Factors On Motivation In Walk Rally Participation of Undergraduate Students at Institute of Physical Education, Chumphon. 7 th Institute of Physical Education International Conference   (pp. 211-217). Bangkok: Institute of Physical Education.',
              'year': 2560
            }
          ],
          '2561': [],
          '2562': [
            {
              'link': '',
              'name': 'วัชชิรา ศักดิ์สนิท และคณะ. (2562). ปัจจัยที่มีผลต่อพฤติกรรมสุขภาพ 3อ 2ส ของผู้สูงอายุ: กรณีศึกษาผู้สูงอายุ ตำบลนาชะอัง อำเภอเมือง จังหวัดชุมพร. การประชุมวิชาการระดับชาติ มหาวิทยาลัยราชภัฏภูเก็ต ครั้งที่ 12 : 2562 "การวิจัยสหวิทยาการบนพื้นฐานยุค 5.0" (หน้า 156-167). ภูเก็ต: สถาบันวิจัยและพัฒนา มหาวิทยาลัยราชภัฏภูเก็ต.              ',
              'year': 2562
            }
          ],
          '2563': [
            {
              'link': 'https://drive.google.com/file/d/1cuhIK1QIWUNID-gw8WP_gQ0qWd_5lfJx/view?usp=sharing',
              'name': 'อุไรวรรณ วรกุลรังสรรค์, ธีรดา  ศิริภิรมย์ และชลธิชาสิ้วอินทร์. (2563). การประเมินศักยภาพและความคาดหวังในการจัดตั้งคลังปัญญาของสถาบันการพลศึกษา. การประชุมวิชาการระดับชาติพิบูลสงครามวิจัย ครั้งที่ 6 ประจำปี พ.ศ.2563 (หน้า 536-545). พิษณุโลก: มหาวิทยาลัยราชภัฏพิบูลสงคราม.'
            }
          ],
          '2564': [
            {
              'link': '',
              'name': 'จิรายุทธ  คงพยัคฆ์, อุไรวรรณ  วรกุลรังสรรค์ และธีรดา  ศิริภิรมย์. (2564). ปัจจัยการมีส่วนร่วมทางการเมืองของนักศึกษามหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตภาคใต้. การประชุมวิชาการระดับชาติ สาขามนุษยศาสตร์และสังคมศาสตร์ ครั้งที่ 5 ประจำปี 2564 (รูปแบบออนไลน์.',
              'year': 2563
            }
          ],
          '2565': [
            {
              'link': '',
              'name': 'อุไรวรรณ วรกุลรังสรรค์, ธีรดา ศิริภิรมย์ และณัฐสุดา เพชรวงศ์. (2565). การดำเนินงานเพื่อเชื่อมโยงสู่ฐานข้อมูล TDC ของมหาวิทยาลัยการกีฬาแห่งชาติ. รายงานสืบเนื่องจากงานประชุมวิชาการระดับชาตินนทรีอีสาน ครั้งที่ 10 ประจำปี 2565 (น.1443 – 1450) . มหาวิทยาลัยเกษตรศาสตร์ วิทยาเขตเฉลิมพระเกียรติ จังหวัดสกลนคร.',
              'year': 2565
            }
          ],
          '2566': [
            {
              'link': '',
              'name': 'กฤษณะ เริงสูงเนิน, ธีรดา ศิริภิรมย์ และอธิษฐ์พัชร์ เพ็ชรไทย. (2566). ความต้องการศึกษาต่อในระดับปริญญาโทของพนักงานบริษัทเอกชนในจังหวัดชุมพร. วารสารมนุษยศาสตร์และสังคมศาสตร์ มมร วิทยาเขตอีสาน., 4(2), 12 – 22.',
              'year': 2566
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'ภาษาอังกฤษเพื่อการสื่อสาร'
      },
      {
        'faculty': 'คณะศิลปศาสตร์',
        'graduated': {
          'field': [ 'Doctor Sport Management (D.S.M)  Sport Management', 'การศึกษามหาบัณฑิต (กศ.ม)  สาขาวิชาพลศึกษา', 'วิทยาศาสตรมหาบัณฑิต (วท.ม) สาขาวิชาการจัดการนันทนาการ', 'วิทยาศาสตรบัณฑิต (วท.บ) สาขาวิชาสันทนาการ' ],
          'university': [ 'United States Sports Academy', 'มหาวิทยาลัยศรีนครินทรวิโรฒ', 'มหาวิทยาลัยศรีนครินทรวิโรฒ', 'มหาวิทยาลัยศรีนครินทรวิโรฒ' ]
        },
        'name': 'ดร.อัศวิน  มณีอินทร์',
        'position': '',
        'publish': {
          '2560': [
            {
              'link': '',
              'name': 'Asawin Maneein, et al.  (2017). The Influential Factors On Motivation In Walk Rally Participation of Undergraduate Students at Institute of Physical Education, Chumphon. 7 th Institute of Physical Education International Conference    (pp. 211-217). Bangkok: Institute of Physical Education.',
              'year': 2560
            }
          ],
          '2561': [
            {
              'link': '',
              'name': 'Chomwart Phetdaeng, Asawin Maneein and Nongluk  Santiwanit.  (2018). The Effect of Think and WalkRally Activities Program Toward Emotional Quotient Development of Three Institutes of Higher Education Students in Chumphon. 8 th Institute of Physical Education International Conference (pp. 370-378). Bangkok: Institute of Physical Education.',
              'year': 2561
            }
          ],
          '2562': [
            {
              'link': '',
              'name': 'Nikorn Selael and et al. (2019). Innovation of Exciting & Challengig Activities for Elderly : Phasel Elderly activities Need and How to Create Exercise Equipment for Them. 9 th Institute of Physical Education International Conference. (หน้า 242-255). Bangkok: Institute of Physical Education.',
              'year': 2562
            },
            {
              'link': '',
              'name': 'Chomwart Phetdaeng and Asawin Maneein. (2019). Radio Program Development “Mental Relaxation by IPE Chumphon” for Radio Moderator of Institute of Physical Education Chumphon Campus Students. 9 th Institute of Physical Education International Conference. (หน้า 233-241). Bangkok: Institute of Physical Education.              ',
              'year': 2562
            }
          ],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [
            {
              'link': '',
              'name': 'อมรินทร์ หัตถกิจ, จิรยุทธ คงพยัคฆ์, ทัศนียา ถึงอินทร์, จิราภรณ์ ขาวศรี, อัศวิน มณีอินทร์ และ วนิดา พูลนวล. (2566). การประเมินความพึงพอใจของประชาชนในเขตเทศบาลเมืองชุมพรที่มีต่อการจัดกิจกรรมโปรแกรมลีลาศกับเกมนันทนาการ และกิจกรรมโปรแกรมลีลาศกับการร้องเพลงคาราโอเกะ : กรณีศึกษาผู้สูงอายุชมรมลีลาศจังหวัดชุมพร. ใน พราม อินพรม และธีรนันท์ ตันพานิช (บ.ก.). การประชุมวิชาการแห่งชาติ สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย (น. 112 - 123). สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย.',
              'year': 2566
            }
          ],
          '2567': [],
          '2568': [
            {
              'link': 'https://drive.google.com/file/d/1KRCt8I558DCdifQ3QtD0IREYPffjM9j7/view',
              'name': 'จิราภรณ์ ขาวศรี, ทัศนียา ถึงอินทร์, จิรยุทธ คงพยัคฆ์, อมรินทร์ หัตถกิจ และอัศวิน มณีอินทร์.  (2568). ความคิดเห็นต่อหลักสูตรศิลปศาสตรบัณฑิต สาขาการท่องเที่ยวและนันทนาการ มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร. ใน นิตย์ ศรีแสงเดือน (บ.ก.). การประชุมวิชาการระดับชาติ ครั้งที่ 15 ประจำปีการศึกษา 2567 หัวข้อ “การศึกษาในยุค AI” โอกาสหรือวิกฤต ?. (น.254 – น.264). วิทยาลัยเทคโนโลยีภาคใต้. ',
              'year': 2568
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'นันทนาการ,การจัดการกีฬา'
      },
      {
        'faculty': 'คณะศิลปศาสตร์',
        'graduated': {
          'field': [ 'ศิลปศาสตรมหาบัณฑิต (ศศ.ม) สาขาวิชากีฬา นันทนาการและการท่องเที่ยว', 'ศิลปศาสตรบัณฑิต (ศศ.บ) สาขาวิชาการจัดการทั่วไป' ],
          'university': [ 'มหาวิทยาลัยศรีนครินทรวิโรฒ', 'สถาบันราชภัฏอุบลราชธานี' ]
        },
        'name': 'นายอัมรินทร์  หัตถกิจ',
        'position': '',
        'publish': {
          '2560': [
            {
              'link': '',
              'name': 'Asawin Maneein, et al. (2017). The Influential Factors On Motivation In Walk Rally Participation of Undergraduate Students at Institute of Physical Education, Chumphon. 7 th Institute of Physical Education International Conference   (pp. 211-217). Bangkok: Institute of Physical Education.',
              'year': 2560
            }
          ],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [
            {
              'link': '',
              'name': 'อมรินทร์ หัตถกิจ, จิรยุทธ คงพยัคฆ์, ทัศนียา ถึงอินทร์, จิราภรณ์ ขาวศรี, อัศวิน มณีอินทร์ และ วนิดา พูลนวล. (2566). การประเมินความพึงพอใจของประชาชนในเขตเทศบาลเมืองชุมพรที่มีต่อการจัดกิจกรรมโปรแกรมลีลาศกับเกมนันทนาการ และกิจกรรมโปรแกรมลีลาศกับการร้องเพลงคาราโอเกะ : กรณีศึกษาผู้สูงอายุชมรมลีลาศจังหวัดชุมพร. ใน พราม อินพรม และธีรนันท์ ตันพานิช (บ.ก.). การประชุมวิชาการแห่งชาติ สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย (น. 112 - 123). สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย.',
              'year': 2566
            }
          ],
          '2567': [],
          '2568': [
            {
              'link': 'https://drive.google.com/file/d/1KRCt8I558DCdifQ3QtD0IREYPffjM9j7/view',
              'name': 'จิราภรณ์ ขาวศรี, ทัศนียา ถึงอินทร์, จิรยุทธ คงพยัคฆ์, อมรินทร์ หัตถกิจ และอัศวิน มณีอินทร์.  (2568). ความคิดเห็นต่อหลักสูตรศิลปศาสตรบัณฑิต สาขาการท่องเที่ยวและนันทนาการ มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร. ใน นิตย์ ศรีแสงเดือน (บ.ก.). การประชุมวิชาการระดับชาติ ครั้งที่ 15 ประจำปีการศึกษา 2567 หัวข้อ “การศึกษาในยุค AI” โอกาสหรือวิกฤต ?. (น.254 – น.264). วิทยาลัยเทคโนโลยีภาคใต้. ',
              'year': 2568
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'นันทนาการ'
      },
      {
        'faculty': 'คณะศิลปศาสตร์',
        'graduated': {
          'field': [ 'Master degree Administration (MTA)  Tourism Administration', 'วิทยาศาสตรบัณฑิต (วท.บ) สาขาวิชาบริหารธุรกิจเกษตร' ],
          'university': [ 'Bangalore university', 'สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง' ]
        },
        'name': 'นางสาวทัศนียา  ถึงอินทร์',
        'position': '',
        'publish': {
          '2560': [
            {
              'link': '',
              'name': ' Asawin Maneein, et al.  (2017). The Influential Factors On Motivation In Walk Rally Participation of Undergraduate Students at Institute of Physical Education, Chumphon. 7 th Institute of Physical Education International Conference    (pp. 211-217). Bangkok: Institute of Physical Education.',
              'year': 2560
            },
            {
              'link': '',
              'name': 'Raphee Laehleemeen, et al.  (2017). The Effectivveness of Public Relation Media Management Organized by the Faculty of Liberal Arts, Institute of Physical Education, Yaly Campus. 7 th Institute of Physical Education International Conference (pp. 522-528). Bangkok: Institute of Physical Education.',
              'year': 2560
            }
          ],
          '2561': [
            {
              'link': '',
              'name': 'Thasaneeya Tungin. (2019). Attitudes of Students towards Teaching and Learning Process in Tourism Specification Modules, Faculty of Liberal Arts, Institute of Physical Education Chumphon Campus. 9 th Institute of Physical Education International Conference. (หน้า 839-846). Bangkok: Institute of Physical Education.',
              'year': 2561
            }
          ],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [
            {
              'link': '',
              'name': 'อมรินทร์ หัตถกิจ, จิรยุทธ คงพยัคฆ์, ทัศนียา ถึงอินทร์, จิราภรณ์ ขาวศรี, อัศวิน มณีอินทร์ และ วนิดา พูลนวล. (2566). การประเมินความพึงพอใจของประชาชนในเขตเทศบาลเมืองชุมพรที่มีต่อการจัดกิจกรรมโปรแกรมลีลาศกับเกมนันทนาการ และกิจกรรมโปรแกรมลีลาศกับการร้องเพลงคาราโอเกะ : กรณีศึกษาผู้สูงอายุชมรมลีลาศจังหวัดชุมพร. ใน พราม อินพรม และธีรนันท์ ตันพานิช (บ.ก.). การประชุมวิชาการแห่งชาติ สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย (น. 112 - 123). สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย.',
              'year': 2566
            }
          ],
          '2567': [],
          '2568': [
            {
              'link': 'https://drive.google.com/file/d/1MYQhfcDOIYtvaotTmZFg2v1etOliIWPT/view',
              'name': 'ทัศนียา ถึงอินทร์ และเป็นหนึ่ง เกิดดำ. (2568). พฤติกรรมและแรงจูงใจการท่องเที่ยวเชิงสุขภาพของผู้สูงอายุจังหวัดชุมพร. ใน นิตย์ ศรีแสงเดือน (บ.ก.).  การประชุมวิชาการระดับชาติ ครั้งที่ 15 ประจำปีการศึกษา 2567 หัวข้อ “การศึกษาในยุค AI” โอกาสหรือวิกฤต ?. (น.130 – น.137). วิทยาลัยเทคโนโลยีภาคใต้. ',
              'year': 2568
            },
            {
              'link': 'https://drive.google.com/file/d/1KRCt8I558DCdifQ3QtD0IREYPffjM9j7/view',
              'name': 'จิราภรณ์ ขาวศรี, ทัศนียา ถึงอินทร์, จิรยุทธ คงพยัคฆ์, อมรินทร์ หัตถกิจ และอัศวิน มณีอินทร์.  (2568). ความคิดเห็นต่อหลักสูตรศิลปศาสตรบัณฑิต สาขาการท่องเที่ยวและนันทนาการ มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร. ใน นิตย์ ศรีแสงเดือน (บ.ก.). การประชุมวิชาการระดับชาติ ครั้งที่ 15 ประจำปีการศึกษา 2567 หัวข้อ “การศึกษาในยุค AI” โอกาสหรือวิกฤต ?. (น.254 – น.264). วิทยาลัยเทคโนโลยีภาคใต้. ',
              'year': 2568
            }
          ]
        },
        'research': {
          '2560': [
            {
              'budget': '50000',
              'doc': 'https://drive.google.com/file/d/1jGzVzwBvNbTpkTIT6Kz9JaKEMvJtpKko/view?usp=sharing',
              'name': 'ทัศนียา ถึงอินทร์. (2560). ทัศนคติของนักศึกษาคณะศิลปศาสตร์ สถาบันการพลศึกษา วิทยาเขตชุมพร ที่มีต่อการจัดการเรียนการสอนกลุ่มวิชาเฉพาะด้านการท่องเที่ยว. ชุมพร: สถาบันการ  พลศึกษา วิทยาเขตชุมพร.              ',
              'role': 'ผู้วิจัยหลัก',
              'year': 2560
            }
          ],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [],
          '2567': [],
          '2568': [
            {
              'budget': '29575',
              'doc': '',
              'name': 'ทัศนียา ถึงอินทร์. (2560). ปัจจัยส่วนประสมทางการตลาดที่มีผลต่อการตัดสินใจท่องเที่ยวเชิงกีฬาทางทะเลจังหวัดชุมพร. ชุมพร: มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร.              ',
              'role': 'ผู้วิจัยหลัก',
              'year': 2568
            }
          ]
        },
        'specialization': 'การบริหารการท่องเที่ยว'
      },
      {
        'faculty': 'คณะศิลปศาสตร์',
        'graduated': {
          'field': [ 'ศิลปศาสตรมหาบัณฑิต (ศศ.ม) สาขาวิชาการจัดการธุรกิจท่องเที่ยวและบริการฯ', 'บริหารธุรกิจบัณฑิต (บธ.บ) สาขาวิชาการตลาด' ],
          'university': [ 'สถาบันบัณฑิตพัฒนบริหารศาสตร์', 'มหาวิทยาลัยสงขลานครินทร์' ]
        },
        'name': 'นางสาวจิราภรณ์  ขาวศรี',
        'position': '',
        'publish': {
          '2560': [
            {
              'link': '',
              'name': 'Asawin Maneein, et al.  (2017). The Influential Factors On Motivation In Walk Rally Participation of Undergraduate Students at Institute of Physical Education, Chumphon. 7 th Institute of Physical Education International Conference (pp. 211-217).Bangkok: Institute of Physical Education.',
              'year': 2560
            },
            {
              'link': '',
              'name': 'สิริปุณยากร  ไกรเทพ และจิราภรณ์  ขาวศรี (2561). พฤติกรรมนักท่องเที่ยวและแนวทางในการวิเคราะห์นักท่องเที่ยวเพื่อพัฒนาทางเลือกในการตัดสินใจซื้อสินค้าที่ระลึก. การประชุมวิชาการระดับชาติด้านการท่องเที่ยวโดยชุมชน ครั้งที่ 1 (pp. 203-213). ตรัง: วิทยาลัยการโรงแรมและการท่องเที่ยว มหาวิทยาลัยเทคโนโลยีราชมงคล  ศรีวิชัย วิทยาเขตตรัง.',
              'year': 2560
            }
          ],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [
            {
              'link': '',
              'name': 'อมรินทร์ หัตถกิจ, จิรยุทธ คงพยัคฆ์, ทัศนียา ถึงอินทร์, จิราภรณ์ ขาวศรี, อัศวิน มณีอินทร์ และ วนิดา พูลนวล. (2566). การประเมินความพึงพอใจของประชาชนในเขตเทศบาลเมืองชุมพรที่มีต่อการจัดกิจกรรมโปรแกรมลีลาศกับเกมนันทนาการ และกิจกรรมโปรแกรมลีลาศกับการร้องเพลงคาราโอเกะ : กรณีศึกษาผู้สูงอายุชมรมลีลาศจังหวัดชุมพร. ใน พราม อินพรม และธีรนันท์ ตันพานิช (บ.ก.). การประชุมวิชาการแห่งชาติ สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย (น. 112 - 123). สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย.',
              'year': 2566
            }
          ],
          '2567': [],
          '2568': [
            {
              'link': 'https://drive.google.com/file/d/1KRCt8I558DCdifQ3QtD0IREYPffjM9j7/view',
              'name': 'จิราภรณ์ ขาวศรี, ทัศนียา ถึงอินทร์, จิรยุทธ คงพยัคฆ์, อมรินทร์ หัตถกิจ และอัศวิน มณีอินทร์.  (2568). ความคิดเห็นต่อหลักสูตรศิลปศาสตรบัณฑิต สาขาการท่องเที่ยวและนันทนาการ มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร. ใน นิตย์ ศรีแสงเดือน (บ.ก.). การประชุมวิชาการระดับชาติ ครั้งที่ 15 ประจำปีการศึกษา 2567 หัวข้อ “การศึกษาในยุค AI” โอกาสหรือวิกฤต ?. (น.254 – น.264). วิทยาลัยเทคโนโลยีภาคใต้. ',
              'year': 2568
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [],
          '2567': [
            {
              'budget': '31120',
              'doc': '',
              'name': 'จิราภรณ์  ขาวศรี. (2567). แนวทางการพัฒนาสินค้าที่ระลึกเพื่อการท่องเที่ยวที่สะท้อนอัตลักษณ์ท้องถิ่น จังหวัดชุมพร. ชุมพร: มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยหลัก',
              'year': 2567
            }
          ],
          '2568': [
            {
              'budget': '196,000',
              'doc': '',
              'name': 'รังสิมาภรณ์ หนูน้อย จิราภรณ์  ขาวศรี และเจนวิทย์  ดิษขนาน. (2568). การพัฒนาแบบวัดทักษะการคิดเชิงบริหารสำหรับนักศึกษามหาวิทยาลัยการกีฬาแห่งชาติ. ชุมพร: มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยร่วม',
              'year': 2568
            }
          ]
        },
        'specialization': 'การจัดการธุรกิจท่องเที่ยว'
      },
      {
        'faculty': 'คณะศึกษาศาสตร์',
        'graduated': {
          'field': [ 'การศึกษาดุษฎีบัณฑิต (กศ.ด) สาขาวิชาเทคโนโลยีและสื่อสารการศึกษา', 'วิทยาศาสตรมหาบัณฑิต (วท.ม) สาขาวิชาวิทยาศาสตร์คอมพิวเตอร์', 'บริหารธุรกิจบัณฑิต (บธ.บ) คอมพิวเตอร์ธุรกิจ' ],
          'university': [ 'มหาวิทยาลัยนเรศวร', 'สถาบันเทคโนโลยีจอมเกล้าคุณทหารลาดกระบัง', 'มหาวิทยาลัยสงขลานครินทร์' ]
        },
        'name': 'ดร.นฤมล  รอดเนียม',
        'position': 'ผู้ช่วยศาสตราจารย์',
        'publish': {
          '2560': [
            {
              'link': '',
              'name': 'Klanarong Krison, et al.  (2017). The Effect of Walk Rally Activities Program Toward Emotional Quotient Development of Students of Institute of Physical Education, Chumphon. 7 th Institute of Physical Education International Conferece (pp. 189-193). Bangkok: Institute of Physical Education.',
              'year': 2560
            },
            {
              'link': '',
              'name': 'Narumon Rodniam. (2017). The Development of the Flipped Model Integrated with the Facebook-Based Learning Platfor to Enhance Lifelong Learning Skills for Undergraduate Physical Education Majors. International Journal of the computer, the Interner and Management , January - April 2017,  50-57.',
              'year': 2560
            }
          ],
          '2561': [
            {
              'link': '',
              'name': 'Anuphong Narachon, et al. (2018). Multimedia Development for Sports and Tourism Information Toward National Youth Games 2017 Chumphon, Thailand. 8 th Institute of Physical Education International Conferece (pp. 379-387). Bangkok: Institute of Physical Education.',
              'year': 2561
            }
          ],
          '2562': [
            {
              'link': '',
              'name': 'Narumon Rodniam and Nonglak Santiwanit. (2019). Guideline for Developing Emotional Intelligence among Physical Education Sutdent Teachers of Institute of Physical Education, Chumphon Campus. 9 th Institute of Physical Education International Conference. (หน้า 334-343). Bangkok: Institute of Physical Education.',
              'year': 2562
            },
            {
              'link': '',
              'name': 'สุพรรษา น้อยนคร รุจโรจน์ แก้วอุไร และนฤมล รอดเนียม. (2562). การส่งเสริมการแก้ปัญหาอย่างสร้างสรรค์ด้วยการจัดการเรียนการสอนแบบโครงงานเป็นฐานบูรณาการกับเฟซบุ๊ก. ศึกษาศาสตร์ มหาวิทยาลัยนเรศวร, 21 (1), 361-376.              ',
              'year': 2562
            },
            {
              'link': '',
              'name': 'Nikorn Selae, et al. (2019). Innovation of Exciting & Challengig Activities for Elderly : Phasel Elderly activities Need and How to Create Exercise Equipment for Them. Proceedings 9th Institute of Physical Education International Conference, Bangkok Thailand, 19 – 21 May 2019, p.265-278.',
              'year': 2562
            }
          ],
          '2563': [
            {
              'link': '',
              'name': 'Narumon Rodniam. (2020). Digital Literracy Assessment of Undergraduate Students from Physical Education Program of Thailand National Sports Universiry. the International Conference e-Learing 2020 (หน้า 132-138). Zagreb: Croatia.              ',
              'year': 2563
            }
          ],
          '2564': [],
          '2565': [
            {
              'link': '',
              'name': 'วงศ์พันธ์ ชูดำ, นฤมล รอดเนียม, สุทัศน์ สีแก้วเขียว และนิธิกร คล้ายสุวรรณ. (2565). แนวทางสร้างเสริมสุขภาวะในการทำงานของผู้หญิงวัยทำงานจังหวัดชายแดนใต้. วารสารวิชาการ มหาวิทยาลัยการกีฬาแห่งชาติ, 14(3), 253 – 266.             ',
              'year': 2565
            }
          ],
          '2566': [
            {
              'link': '',
              'name': 'อนุรักษ์ ปักการะนัง, ดามพ์ สุขสุวานนท์, เจนวิทย์ ดิษขนาน, รังสิมาภรณ์ หนูน้อย, กาญจนา ฐานะ, เฉลิมพล ก่อกิจเถกิงกูล, ฤทัย เพชรสุวรรณ, สันติพร เชื้อไทย และนฤมล รอดเนียม. (2566). การศึกษาความต้องการของผู้ใช้บัณฑิตต่อคุณลักษณะบัณฑิตหลักสูตรศึกษาศาสตรบัณฑิต สาขาพลศึกษา มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร. ใน พราม อินพรม และธีรนันท์ ตันพานิช (บ.ก.). การประชุมวิชาการแห่งชาติ สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย (น. 300- 310). สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย.',
              'year': 2566
            }
          ],
          '2567': [
            {
              'link': 'https://he02.tci-thaijo.org/index.php/TNSUJournal/article/download/263012/184678/1155835',
              'name': 'นฤมล รอดเนียม,ธเนศพล สุขสด และอนุรักษ์ ปักการะนัง. (2567). ผลการใช้โปรแกรมกิจกรรมทางกายด้านกีฬาและนันทนาการตามนโยบายลดเวลาเรียนเพิ่มเวลารู้ที่มีต่อการพัฒนาความฉลาดทางอารมณ์ของนักเรียนประถมศึกษาปีที่ 4-6. วารสารวิชาการ มหาวิทยาลัยการกีฬาแห่งชาติ. 16(3), หน้า 191 - 202 ',
              'year': 2567
            }
          ],
          '2568': [
            {
              'link': 'https://ccsenet.org/journal/index.php/hes/article/view/0/50813',
              'name': 'Rodniam, N., & Suksuwanont, D. (2024). A development of online problem-based learning model to promote self-regulated learning among undergraduates. Higher Education Studies, 14(4), 153-167. ',
              'year': 2568
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [
            {
              'budget': '',
              'doc': 'https://drive.google.com/file/d/1vPCo9vVnbJaicT9dBbV_Zk-ryMLT4XJ1/view?usp=sharing',
              'name': 'วงศ์พัทธ์  ชูดำ และคณะ. (2562). การพัฒนารูปแบบนวัตกรรมการส่งเสริมสุขภาวะในการทำงานของผู้หญิงวัยทำงาน จังหวัดชายแดนใต้. ตรัง: สถาบันการพลศึกษา ',
              'role': 'ผู้วิจัยร่วม',
              'year': 2562
            },
            {
              'budget': '50000',
              'doc': 'https://drive.google.com/file/d/1wQ59Q2GzZJGXN5-MqBAV6ntSGyjZ-a3-/view?usp=sharing',
              'name': 'นฤมล รอดเนียม. (2562). การประเมินการรู้ดิจิทัลของนักศึกษาระดับปริญญาตรี สาขาพลศึกษา สถาบันการพลศึกษา. ชุมพร: มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร.              ',
              'role': 'ผู้วิจัยหลัก',
              'year': 2562
            },
            {
              'budget': '50000',
              'doc': 'https://drive.google.com/file/d/1yRLtpkCM342kA5H4XwOTBu3JOvdONgt2/view?usp=sharing',
              'name': 'นงลักษณ์ สันติวณิชย์ และนฤมล  รอดเนียม. (2562).  ผลการใช้โปรแกรมการจัดกิจกรรมทางกายด้านกีฬาและนันทนาการตามนโยบายลดเวลาเรียนเพิ่มเวลารู้ที่มีผลต่อการพัฒนาความฉลาดทางอารมณ์ของนักเรียนชั้นประถมศึกษาชั้นปีที่ 4 - 6. ชุมพร: มหาวิทยาลัยการกีฬาแห่งชาติ  วิทยาเขตชุมพร',
              'role': 'ผู้วิจัยร่วม',
              'year': 2562
            }
          ],
          '2563': [],
          '2564': [
            {
              'link': '',
              'name': 'พงษ์ศักด์ ผกามาศ, และคณะ (2564). ปัจจัยเชิงกลยุทธ์องค์กรที่ส่งผลต่อความสำเร็จของการใช้แพลตฟอร์มการศึกษาดิจิทัลของสถาบันอุดมศึกษาในภาคตะวันออกเฉียงเหนือ. การประชุมวิชาการ The 9 th PSU Education Conference (Online) (หน้า 283 - 293).สงขลา:มหาวิทยาลัยสงขลานครินทร์.',
              'year': 2564
            },
            {
              'link': '',
              'name': 'สุริยะ วชิรวงศ์ไพศาล, และคณะ. (2564). การศึกษาองค์ประกอบของการจัดองค์กรแห่งนวัตกรรมทางการศึกษายุคดิจิทัลสำหรับสถานศึกษาขั้นพื้นฐานที่เหมาะสมในประเทศไทย. การประชุมวิชาการ The 9 th PSU Education Conference (Online) (หน้า 294 - 306). สงขลา: มหาวิทยาลัยสงขลานครินทร์.',
              'year': 2564
            },
            {
              'link': '',
              'name': 'Suriya Wachirawongpaisarn, Ritthidech Phomdee, Phongsak Phakamach, Darunee Panjarattanakorn and Narumon Rodniam. (2021). A Conceptual Juristic School Administration Framework by Guidelines for Quality Excellence in Thailand 4.0 Education Reform and Implementation. The Second RMUTR International Conference Proceedings 2021 The First RICE International Conference Proceedings. (pp. 226 – 236). Nakhon Pathom: Rajamangala University of Technology Rattanakosin.',
              'year': 2564
            }
          ],
          '2565': []
        },
        'specialization': 'เทคโนโลยีการศึกษา'
      },
      {
        'faculty': 'คณะศึกษาศาสตร์',
        'graduated': {
          'field': [ 'การศึกษามหาบัณฑิต (กศ.ม) สาขาวิชาพลศึกษา', 'การศึกษาบัณฑิต (กศ.บ) สาขาวิชาพลศึกษา' ],
          'university': [ 'มหาวิทยาลัยศรีนครินทรวิโรฒ', 'วิทยาลัยครูกาญจนบุรี' ]
        },
        'name': 'นายธเนศพล  สุขสด',
        'position': 'ผู้ช่วยศาสตราจารย์',
        'publish': {
          '2560': [],
          '2561': [
            {
              'link': '',
              'name': 'Rungsimaporn Noonoi, Nattaya Niltachan and Tanetpol Suksod.  (2018). Development of the Self-Direcred Learning Characrerisrics Scale for Institute of Physical Education, Chumphon Campus Students. 8 th Institute of Physical Education International Conferece (pp.1084-1091). Bangkok: Institute of Physical Education.',
              'year': 2561
            }
          ],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [],
          '2567': [
            {
              'link': 'https://he02.tci-thaijo.org/index.php/TNSUJournal/article/download/263012/184678/1155835',
              'name': 'นฤมล รอดเนียม,ธเนศพล สุขสด และอนุรักษ์ ปักการะนัง. (2567). ผลการใช้โปรแกรมกิจกรรมทางกายด้านกีฬาและนันทนาการตามนโยบายลดเวลาเรียนเพิ่มเวลารู้ที่มีต่อการพัฒนาความฉลาดทางอารมณ์ของนักเรียนประถมศึกษาปีที่ 4-6. วารสารวิชาการ มหาวิทยาลัยการกีฬาแห่งชาติ. 16(3), หน้า 191 - 202 ',
              'year': 2567
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'พลศึกษา,วอลเลย์บอล'
      },
      {
        'faculty': 'คณะศึกษาศาสตร์',
        'graduated': {
          'field': [ 'ครุศาสตรมหาบัณฑิต (ค.ม) สาขาวิชาหลักสูตรและการสอ', 'ศิลปศาสตรบัณฑิต (ศศ.บ) สาขาวิชาการจัดการทั่วไ' ],
          'university': [ 'มหาวิทยาลัยราชภัฏบ้านสมเด็จเจ้าพระยา', 'วิทยาลัยครูภูเก็ต' ]
        },
        'name': 'นายสำเริง  วงศ์พลาย',
        'position': 'ผู้ช่วยศาสตราจารย์',
        'publish': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [
            {
              'budget': '50000',
              'doc': 'https://drive.google.com/file/d/1_-uqlBAnovzTAbUjIli1h9NG6b0XRveG/view?usp=sharing',
              'name': 'สำเริง  วงศ์พลาย(2562). การพัฒนาบทเรียนอีเลิร์นนิงบนเครือข่ายอินเทอร์เน็ต: การพัฒนาหลักสูตร. ชุมพร: มกาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยหลัก',
              'year': 2562
            }
          ],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'หลักสูตรและการสอน'
      },
      {
        'faculty': 'คณะศึกษาศาสตร์',
        'graduated': {
          'field': [ 'การศึกษามหาบัณฑิต (กศ.ม) สาขาวิชาพลศึกษา', 'ศิลปศาสตรบัณฑิต (ศศ.บ) สาขาวิชาพลศึกษา' ],
          'university': [ 'มหาวิทยาลัยศรีนครินทรวิโรฒประสานมิตร', '', '', '' ]
        },
        'name': 'นายวีรยุทธ  สุวรรณศิริ',
        'position': 'ผู้ช่วยศาสตราจารย์',
        'publish': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'พลศึกษา'
      },
      {
        'faculty': 'คณะศึกษาศาสตร์',
        'graduated': {
          'field': [ 'การศึกษามหาบัณฑิต (กศ.ม) สาขาวิชาพลศึกษา', 'วิทยาศาสตรบัณฑิต (วท.บ) สาขาวิชาพลศึกษา' ],
          'university': [ 'มหาวิทยาลัยศรีนครินทรวิโรฒ ประสานมิตร', 'มหาวิทยาลัยศรีนครินทรวิโรฒ พลศึกษา' ]
        },
        'name': 'นายเฉลิมพล  ก่อกิจเถกิงกูล',
        'position': '',
        'publish': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [
            {
              'link': '',
              'name': 'อนุรักษ์ ปักการะนัง, ดามพ์ สุขสุวานนท์, เจนวิทย์ ดิษขนาน, รังสิมาภรณ์ หนูน้อย, กาญจนา ฐานะ, เฉลิมพล ก่อกิจเถกิงกูล, ฤทัย เพชรสุวรรณ, สันติพร เชื้อไทย และนฤมล รอดเนียม. (2566). การศึกษาความต้องการของผู้ใช้บัณฑิตต่อคุณลักษณะบัณฑิตหลักสูตรศึกษาศาสตรบัณฑิต สาขาพลศึกษา มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร. ใน พราม อินพรม และธีรนันท์ ตันพานิช (บ.ก.). การประชุมวิชาการแห่งชาติ สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย (น. 300- 310). สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย.',
              'year': 2566
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'พลศึกษา,ฟุตบอล'
      },
      {
        'faculty': 'คณะศึกษาศาสตร์',
        'graduated': {
          'field': [ 'การศึกษามหาบัณฑิต (กศ.ม) สาขาวิชาพลศึกษา', 'การศึกษาบัณฑิต (กศ.บ) สาขาวิชาพลศึกษา' ],
          'university': [ 'มหาวิทยาลัยศรีนครินทรวิโรฒ ประสานมิตร', 'มหาวิทยาลัยศรีนครินทรวิโรฒ พลศึกษา' ]
        },
        'name': 'นายดามพ์  สุขสุวานนท์',
        'position': '',
        'publish': {
          '2560': [],
          '2561': [
            {
              'link': '',
              'name': 'Maliwan Piwkram, Damp Suksuwanont and Pichai Piwkram.  (2018). The Development for General Ability that the Calculations to Prepare for the Entrance Examination to Working in the Government : Case Study that the Sudents Faculty of Education 3 rd Years class, Institute of Physical Education Chumphon. 8 th Institute of Physical Education International Conferece (pp. 1069-1075). Bangkok: Institute of Physical Education.',
              'year': 2561
            }
          ],
          '2562': [
            {
              'link': '',
              'name': 'Pornkanok, Kasamruangsagul,Damp Suksuwanont and Rungsimaporn Noonoi. (2019). The Effect of Plyometric Training to Lay-Up Shot on the Ability : A Case Study Basketball Player Institute of Physical Education Chumphon Campus. 9 th Institute of Physical Education International Conference. (หน้า 1047-1053). Bangkok: Institute of Physical Education.',
              'year': 2562
            },
            {
              'link': '',
              'name': 'Padungsak Klangduan, Damp Suksuwanont and Pichai Piwkram. (2019). The Effects Training by Medicine Ball is Long Distance Three Points Shooting Ability of Basketball Player. 9 th Institute of Physical Education International Conference. (หน้า 1035-1040). Bangkok: Institute of Physical Education.',
              'year': 2562
            }
          ],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [
            {
              'link': '',
              'name': 'อนุรักษ์ ปักการะนัง, ดามพ์ สุขสุวานนท์, เจนวิทย์ ดิษขนาน, รังสิมาภรณ์ หนูน้อย, กาญจนา ฐานะ, เฉลิมพล ก่อกิจเถกิงกูล, ฤทัย เพชรสุวรรณ, สันติพร เชื้อไทย และนฤมล รอดเนียม. (2566). การศึกษาความต้องการของผู้ใช้บัณฑิตต่อคุณลักษณะบัณฑิตหลักสูตรศึกษาศาสตรบัณฑิต สาขาพลศึกษา มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร. ใน พราม อินพรม และธีรนันท์ ตันพานิช (บ.ก.). การประชุมวิชาการแห่งชาติ สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย (น. 300- 310). สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย.',
              'year': 2566
            }
          ],
          '2567': [],
          '2568': [
            {
              'link': 'https://ccsenet.org/journal/index.php/hes/article/view/0/50813',
              'name': 'Rodniam, N., & Suksuwanont, D. (2024). A development of online problem-based learning model to promote self-regulated learning among undergraduates. Higher Education Studies, 14(4), 153-167. ',
              'year': 2568
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [
            {
              'budget': '50000',
              'doc': 'https://drive.google.com/file/d/1Lr6nlk5SegLadANCJwHeXdoG6IoAMl0I/view?usp=sharing',
              'name': 'มลิวัลย์ ผิวคราม, ดามพ์ สุขสุวานนท์ และพิชัย        ผิวคราม. (2561). การพัฒนาความสามารถทั่วไปด้านการคิดคำนวณเพื่อเตรียมความพร้อมในการสอบคัดเลือกเข้ารับราชการ : กรณีศึกษานักศึกษาคณะศึกษาศาสตร์        ชั้นปีที่ 3 สถาบันการพลศึกษา วิทยาเขตชุมพร. ชุมพร: สถาบันการพลศึกษา วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยร่วม',
              'year': 2561
            }
          ],
          '2562': [
            {
              'budget': '50000',
              'doc': '',
              'name': 'ดามพ์ สุขสุวานนท์ และชาญชัย ศิริพันธุ์. (2562). ผลสัมฤทธิ์ทักษะการว่ายน้ำด้วยวิธีการจัดกิจกรรมฝึกทักษะแบบแยกกลุ่มแก้ไขบกพร่อง. ชุมพร: มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร.              ',
              'role': 'ผู้วิจัยหลัก',
              'year': 2562
            }
          ],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'พลศึกษา,บาสเกตบอล'
      },
      {
        'faculty': 'คณะศึกษาศาสตร์',
        'graduated': {
          'field': [ 'ครุศาสตรดุษฎีบัณฑิต (ค.ด.) สาขาการวัดและประเมินผลการศึกษา', 'ศึกษาศาสตรมหาบัณฑิต (ศษ.ม) สาขาวิชาวิจัยและประเมินผลการศึกษา', 'ศึกษาศาสตรบัณฑิต (ศษ.บ) สาขาวิชาการศึกษาตลอดชีวิต' ],
          'university': [ 'จุฬาลงกรณ์มหาวิทยาลัย', 'มหาวิทยาลัยเกษตรศาสตร์', 'มหาวิทยาลัยศิลปากร' ]
        },
        'name': 'นางสาวรังสิมาภรณ์  หนูน้อย',
        'position': 'ผู้ช่วยศาสตราจารย์',
        'publish': {
          '2560': [],
          '2561': [
            {
              'link': '',
              'name': 'Rungsimaporn Noonoi, Nattaya Niltachan and Tanetpol Suksod.  (2018). Development of the Self-Direcred Learning Characrerisrics Scale for Institute of Physical Education, Chumphon Campus Students. 8 th Institute of Physical Education International Conferece (pp.1084-1091). Bangkok: Institute of Physical Education.',
              'year': 2561
            }
          ],
          '2562': [
            {
              'link': '',
              'name': 'Pornkanok, Kasamruangsagul,Damp Suksuwanont and Rungsimaporn Noonoi. (2019). The Effect of Plyometric Training to Lay-Up Shot on the Ability : A Case Study Basketball Player Institute of Physical Education Chumphon Campus. 9 th Institute of Physical Education International Conference. (หน้า 1047-1053). Bangkok: Institute of Physical Education.',
              'year': 2562
            },
            {
              'link': '',
              'name': 'Somphon Rukyou and et al. (2019). The Development to E-Learning Subject of the Knowledge about Swimming to Freestyle for the Students Secondary Grade 1. 9 th Institute of Physical Education International Conference. (หน้า 1041-1046). Bangkok: Institute of Physical Education.              ',
              'year': 2562
            }
          ],
          '2563': [
            {
              'link': '',
              'name': 'วัชชิรา ศักดิ์สนิท และคณะ. (2562). ปัจจัยที่มีผลต่อพฤติกรรมสุขภาพ 3อ 2ส ของผู้สูงอายุ: กรณีศึกษาผู้สูงอายุ ตำบลนาชะอัง อำเภอเมือง จังหวัดชุมพร. การประชุมวิชาการระดับชาติ มหาวิทยาลัยราชภัฏภูเก็ต ครั้งที่ 12 : 2562 "การวิจัยสหวิทยาการบนพื้นฐานยุค 5.0" (หน้า 156-167). ภูเก็ต: สถาบันวิจัยและพัฒนา มหาวิทยาลัยราชภัฏภูเก็ต.              ',
              'year': 2563
            }
          ],
          '2564': [
            {
              'link': '',
              'name': 'รังสิมาภรณ์ หนูน้อย และคณะ (2564) ปัจจัยที่มีผลต่อการเป็นนักกีฬาอีสปอร์ต มหาวิทยาลัยการกีฬาแห่งชาติ วารสารคณะพลศึกษา มหาวิทยาลัยศรีนครินทร  วิโรฒ. 24(2) . หน้า 70-79.',
              'year': 2564
            }
          ],
          '2565': [],
          '2566': [
            {
              'link': '',
              'name': 'อนุรักษ์ ปักการะนัง, ดามพ์ สุขสุวานนท์, เจนวิทย์ ดิษขนาน, รังสิมาภรณ์ หนูน้อย, กาญจนา ฐานะ, เฉลิมพล ก่อกิจเถกิงกูล, ฤทัย เพชรสุวรรณ, สันติพร เชื้อไทย และนฤมล รอดเนียม. (2566). การศึกษาความต้องการของผู้ใช้บัณฑิตต่อคุณลักษณะบัณฑิตหลักสูตรศึกษาศาสตรบัณฑิต สาขาพลศึกษา มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร. ใน พราม อินพรม และธีรนันท์ ตันพานิช (บ.ก.). การประชุมวิชาการแห่งชาติ สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย (น. 300- 310). สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย.',
              'year': 2566
            }
          ],
          '2567': [
            {
              'link': 'https://he02.tci-thaijo.org/index.php/TNSUJournal/article/download/261764/182289/1090505',
              'name': 'รังสิมาภรณ์ หนูน้อย และโชคชัย ปัญญาคำ. (2567). การพัฒนาระบบการทดสอบที่มีการให้ข้อมูลย้อนกลับโดยใช้คอมพิวเตอร์เพื่อการวัดสมรรถนะวิชาชีพครู : สาระความรู้การวิจัยเพื่อแก้ปัญหาและพัฒนาผู้เรียนของนักศึกษา มหาวิทยาลัยการกีฬาแห่งชาติ. วารสารวิชาการมหาวิทยาลัยการกีฬาแห่งชาติ, 16(1), หน้า 227 - 238.',
              'year': 2567
            },
            {
              'link': 'https://so01.tci-thaijo.org/index.php/rdi-aru/article/download/276253/178869/1115407',
              'name': 'รังสิมาภรณ์ หนูน้อย และเจนวิทย์  ดิษขนาน. (2567). การพัฒนาแบบวัดทักษะกีฬากาบัดดี้สำหรับนักศึกษามหาวิทยาลัยการกีฬาแห่งชาติ. วารสารวิจัยราชภัฏกรุงเก่า, 11(3), หน้า 28 - 36.',
              'year': 2567
            }
          ],
          '2568': [
            {
              'link': '',
              'name': 'ฤทัย เพชรสุวรรณ, กาญจนา ฐานะ, เจนวิทย์ ดิษขนาน และรังสิมาภรณ์ หนูน้อย. (2567). การศึกษาความพึงพอใจของบุคลากรในสถานศึกษาที่มีต่อคุณภาพของนักศึกษาปฏิบัติการสอนในสถานศึกษา 4 คณะศึกษาศาสตร์ มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร. ใน พราม อินพรม และธีรนันท์ ตันพานิช (บ.ก.). การประชุมวิชาการแห่งชาติ ครั้งที่ 37 สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย (น. 356- 370). สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย. ',
              'year': 2568
            }
          ]
        },
        'research': {
          '2560': [
            {
              'budget': '50000',
              'doc': 'https://drive.google.com/file/d/1btHyBPZwfcDuR7I7ruaYUv-R__V32LnP/view?usp=sharing',
              'name': 'รังสิมาภรณ์ หนูน้อย และนาฏยา นิลทจันทร์. (2560). การพัฒนาแบบวัดคุณลักษณะการเรียนรู้ด้วยตนเองสำหรับนักศึกษาสถาบันการพลศึกษา วิทยาเขตชุมพร. ชุมพร: สถาบันการพลศึกษา วิทยาเขตชุมพร              ',
              'role': 'ผู้วิจัยหลัก',
              'year': 2560
            }
          ],
          '2561': [],
          '2562': [
            {
              'budget': '50000',
              'doc': 'https://drive.google.com/file/d/1Gqq8IEWQcm-bdN_E9gHAWK6eeT47tQN3/view?usp=sharing',
              'name': 'รังสิมาภรณ์ หนูน้อย และมลิวัลย์ ผิวคราม. (2562). การพัฒนาระบบสารสนเทศเพื่อการบริหารงานวิจัยสถาบันการพลศึกษา วิทยาเขตชุมพร. ชุมพร: สถาบันการพลศึกษา วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยหลัก',
              'year': 2562
            }
          ],
          '2563': [
            {
              'budget': '50000',
              'doc': '',
              'name': 'รังสิมาภรณ์ หนูน้อย. (2563). ปัจจัยที่มีผลต่อการเป็นนักกีฬาอีสปอร์ต มหาวิทยาลัยการกีฬาแห่งชาติ. ชุมพร: มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยหลัก',
              'year': 2563
            }
          ],
          '2564': [
            {
              'budget': '50000',
              'doc': 'https://drive.google.com/file/d/1lc3dyu1BlTIs4p3mXwrMqUnjulk78PI7/view?usp=sharing',
              'name': 'เจนวิทย์  ดิษขนาน และรังสิมาภรณ์  หนูน้อย. (2564). ผลกระทบของสถานการร์การแพร่ระบาดของโรคติดเชื้อไวรัสโคโรนา 2019 ที่มีต่อนักกีฬากาบัดดี้. ชุมพร: มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยร่วม',
              'year': 2564
            }
          ],
          '2565': [],
          '2566': [
            {
              'budget': '28100',
              'doc': '',
              'name': 'รังสิมาภรณ์ หนูน้อย และเจนวิทย์  ดิษขนาน. (2567). การพัฒนาแบบวัดทักษะกีฬากาบัดดี้ สำหรับนักศึกษามหาวิทยาลัยการกีฬาแห่งชาติ. ชุมพร: มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยหลัก',
              'year': 2566
            }
          ],
          '2567': [],
          '2568': [
            {
              'budget': '196,000',
              'doc': '',
              'name': 'รังสิมาภรณ์ หนูน้อย จิราภรณ์  ขาวศรี และเจนวิทย์  ดิษขนาน. (2568). การพัฒนาแบบวัดทักษะการคิดเชิงบริหารสำหรับนักศึกษามหาวิทยาลัยการกีฬาแห่งชาติ. ชุมพร: มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยหลัก',
              'year': 2568
            }
          ]
        },
        'specialization': 'การวิจัยการศึกษา,การวัดและประเมินผลการศึกษา'
      },
      {
        'faculty': 'คณะศึกษาศาสตร์',
        'graduated': {
          'field': [ 'ครุศาสตรมหาบัณฑิต (ค.ม) สาขาวิชาหลักสูตรและการสอน', 'ศิลปศาสตรบัณฑิต (ศศ.บ) สาขาวิชาการจัดการทั่วไป' ],
          'university': [ 'มหาวิทยาลัยราชภัฏบ้านสมเด็จเจ้าพระยา', 'มหาวิทยาลัยราชภัฏสุราษฏร์ธานี' ]
        },
        'name': 'นางฤทัย  เพชรสุวรรณ',
        'position': '',
        'publish': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [
            {
              'link': '',
              'name': 'อนุรักษ์ ปักการะนัง, ดามพ์ สุขสุวานนท์, เจนวิทย์ ดิษขนาน, รังสิมาภรณ์ หนูน้อย, กาญจนา ฐานะ, เฉลิมพล ก่อกิจเถกิงกูล, ฤทัย เพชรสุวรรณ, สันติพร เชื้อไทย และนฤมล รอดเนียม. (2566). การศึกษาความต้องการของผู้ใช้บัณฑิตต่อคุณลักษณะบัณฑิตหลักสูตรศึกษาศาสตรบัณฑิต สาขาพลศึกษา มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร. ใน พราม อินพรม และธีรนันท์ ตันพานิช (บ.ก.). การประชุมวิชาการแห่งชาติ สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย (น. 300- 310). สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย.',
              'year': 2566
            }
          ],
          '2567': [],
          '2568': [
            {
              'link': '',
              'name': 'ฤทัย เพชรสุวรรณ, กาญจนา ฐานะ, เจนวิทย์ ดิษขนาน และรังสิมาภรณ์ หนูน้อย. (2567). การศึกษาความพึงพอใจของบุคลากรในสถานศึกษาที่มีต่อคุณภาพของนักศึกษาปฏิบัติการสอนในสถานศึกษา 4 คณะศึกษาศาสตร์ มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร. ใน พราม อินพรม และธีรนันท์ ตันพานิช (บ.ก.). การประชุมวิชาการแห่งชาติ ครั้งที่ 37 สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย (น. 356- 370). สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย. ',
              'year': 2568
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'หลักสูตรและการสอน'
      },
      {
        'faculty': 'คณะศึกษาศาสตร์',
        'graduated': {
          'field': [ 'ศึกษาศาสตรมหาบัณฑิต (ศษ.ม.) สาขาพลศึกษา', 'ศึกษาศาสตรบัณฑิต (ศษ.บ.) สาขาพลศึกษา' ],
          'university': [ 'สถาบันการพลศึกษา', 'สถาบันการพลศึกษา' ]
        },
        'name': 'ว่าที่ รต.อนุรักษ์ ปักการะนัง',
        'position': '',
        'publish': {
          '2560': [],
          '2561': [],
          '2563': [],
          '2564': [
            {
              'link': '',
              'name': 'รังสิมาภรณ์ หนูน้อย และคณะ (2564) ปัจจัยที่มีผลต่อการเป็นนักกีฬาอีสปอร์ต มหาวิทยาลัยการกีฬาแห่งชาติ วารสารคณะพลศึกษา มหาวิทยาลัยศรีนครินทร  วิโรฒ. 24(2) . หน้า 70-79.',
              'year': 2564
            }
          ],
          '2565': [],
          '2566': [
            {
              'link': '',
              'name': 'อนุรักษ์ ปักการะนัง, ดามพ์ สุขสุวานนท์, เจนวิทย์ ดิษขนาน, รังสิมาภรณ์ หนูน้อย, กาญจนา ฐานะ, เฉลิมพล ก่อกิจเถกิงกูล, ฤทัย เพชรสุวรรณ, สันติพร เชื้อไทย และนฤมล รอดเนียม. (2566). การศึกษาความต้องการของผู้ใช้บัณฑิตต่อคุณลักษณะบัณฑิตหลักสูตรศึกษาศาสตรบัณฑิต สาขาพลศึกษา มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร. ใน พราม อินพรม และธีรนันท์ ตันพานิช (บ.ก.). การประชุมวิชาการแห่งชาติ สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย (น. 300- 310). สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย.',
              'year': 2566
            }
          ],
          '2567': [
            {
              'link': 'https://he02.tci-thaijo.org/index.php/TNSUJournal/article/download/263012/184678/1155835',
              'name': 'นฤมล รอดเนียม,ธเนศพล สุขสด และอนุรักษ์ ปักการะนัง. (2567). ผลการใช้โปรแกรมกิจกรรมทางกายด้านกีฬาและนันทนาการตามนโยบายลดเวลาเรียนเพิ่มเวลารู้ที่มีต่อการพัฒนาความฉลาดทางอารมณ์ของนักเรียนประถมศึกษาปีที่ 4-6. วารสารวิชาการ มหาวิทยาลัยการกีฬาแห่งชาติ. 16(3), หน้า 191 - 202 ',
              'year': 2567
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'พลศึกษา,มวยไทยสมัครเล่น'
      },
      {
        'faculty': 'คณะศึกษาศาสตร์',
        'graduated': {
          'field': [ 'ศึกษาศาสตรมหาบัณฑิต (ศษ.ม.) สาขาจิตวิทยาการศึกษาและการให้คำปรึกษา', 'วิทยาศาสตรบัณฑิต (วท.บ.) สาขาจิตวิทยา' ],
          'university': [ 'มหาวิทยาลัยขอนแก่น', 'มหาวิทยาลัยมหาสารคาม' ]
        },
        'name': 'นายกฤษณะ  เริงสูงเนิน',
        'position': '',
        'publish': {
          '2560': [],
          '2561': [],
          '2563': [],
          '2564': [
            {
              'link': '',
              'name': 'กฤษณะ  เริงสูงเนิน, รสสุคนธ์  ธัญถนอม และวันชัยศิริ พลหาญ. (2564). ความต้องการใช้บริการ การให้คำปรึกษาที่ศูนย์มายแคร์เซ็นเตอร์ของคณะศึกษาศาสตร์ มหาวิทยาลัยขอนแก่น. การประชุมวิชาการระดับชาติ ครั้งที่ 3 พ.ศ. 2564 มหาวิทยาลัยมหามงกุฏราชวิทยาลัย.',
              'year': 2564
            },
            {
              'link': '',
              'name': 'รสสุคนธ์  ธัญถนอม, กฤษณะ  เริงสูงเนิน  และวันชัยศิริ พลหาญ. (2564). การปรับตัวในสถานการณ์โควิด-19 ของนักเรียนประกาศนียบัตรวิชาชีพ วิทยาลัยเทคโนโลยีคุวานันท์. การประชุมวิชาการระดับชาติ ครั้งที่ 3 พ.ศ. 2564 มหาวิทยาลัยมหามงกุฏราชวิทยาลัย.',
              'year': 2564
            }
          ],
          '2565': [],
          '2566': [
            {
              'link': '',
              'name': 'กฤษณะ เริงสูงเนิน, ธีรดา ศิริภิรมย์ และอธิษฐ์พัชร์ เพ็ชรไทย. (2566). ความต้องการศึกษาต่อในระดับปริญญาโทของพนักงานบริษัทเอกชนในจังหวัดชุมพร. วารสารมนุษยศาสตร์และสังคมศาสตร์ มมร วิทยาเขตอีสาน., 4(2), 12 – 22.',
              'year': 2566
            },
            {
              'link': '',
              'name': 'กฤษณะ เริงสูงเนิน. (2566). การพัฒนาโปรแกรมการให้คำปรึกษาแบบกลุ่มที่มีผลต่อความเจริญงอกงามของนักศึกษา มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร. วารสาร มจร.อุบลปริทรรศน์., 8(1) , (749-762).',
              'year': 2566
            }
          ],
          '2567': [
            {
              'link': 'https://so10.tci-thaijo.org/index.php/rdicpru/article/view/1160',
              'name': 'กฤษณะ เริงสูงเนิน. (2567). การพัฒนารูปแบบการใช้คำปรึกษากลุ่มแบบบูรณาการที่มีผลต่อความเหนื่อยหน่าย ในการเรียนของนักเรียน มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร. วารสารสถาบันวิจัยและพัฒนา มหาวิทยาลัยราชภัฏชัยภูมิ ., 6(2), หน้า 12 – 22.',
              'year': 2567
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [],
          '2567': [],
          '2568': [
            {
              'budget': '31900',
              'doc': '',
              'name': 'กฤษณะ เริงสูงเนิน. (2566). การพัฒนารูปแบบการให้คำปรึกษากลุ่มแบบบูรณาการที่มีผลต่อความเหนื่อยหน่ายในการเรียนของนักศึกษา มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร. ชุมพร: มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัย',
              'year': 2568
            }
          ]
        },
        'specialization': 'พลศึกษา, กรีฑา'
      },
      {
        'faculty': 'คณะศึกษาศาสตร์',
        'graduated': {
          'field': [ 'ศึกษาศาสตรมหาบัณฑิต (ศษ.ม.) สาขาพลศึกษา', 'ศึกษาศาสตรบัณฑิต (ศษ.บ.) สาขาพลศึกษา' ],
          'university': [ 'มหาวิทยาลัยการกีฬาแห่งชาติ', 'สถาบันการพลศึกษา' ]
        },
        'name': 'นายวัชระ  ยกฉิม',
        'position': '',
        'publish': {
          '2560': [],
          '2561': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'พลศึกษา, กรีฑา'
      },
      {
        'faculty': 'คณะศึกษาศาสตร์',
        'graduated': {
          'field': [ 'ศิลปศาสตรมหาบัณฑิต (ศศ.ม.)  สาขาพลศึกษา', 'วิทยาศาสตรบัณฑิต (วท.บ.) สาขาวิทยาศาสตร์การกีฬา' ],
          'university': [ 'มหาวิทยาลัยเกษตรศาสตร์', 'มหาวิทยาลัยราชภัฏนครปฐม' ]
        },
        'name': 'อาจารย์กาญจนา ฐานะ',
        'position': '',
        'publish': {
          '2560': [],
          '2561': [],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [
            {
              'link': '',
              'name': 'อนุรักษ์ ปักการะนัง, ดามพ์ สุขสุวานนท์, เจนวิทย์ ดิษขนาน, รังสิมาภรณ์ หนูน้อย, กาญจนา ฐานะ, เฉลิมพล ก่อกิจเถกิงกูล, ฤทัย เพชรสุวรรณ, สันติพร เชื้อไทย และนฤมล รอดเนียม. (2566). การศึกษาความต้องการของผู้ใช้บัณฑิตต่อคุณลักษณะบัณฑิตหลักสูตรศึกษาศาสตรบัณฑิต สาขาพลศึกษา มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร. ใน พราม อินพรม และธีรนันท์ ตันพานิช (บ.ก.). การประชุมวิชาการแห่งชาติ สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย (น. 300- 310). สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย.',
              'year': 2566
            }
          ],
          '2567': [],
          '2568': [
            {
              'link': '',
              'name': 'ฤทัย เพชรสุวรรณ, กาญจนา ฐานะ, เจนวิทย์ ดิษขนาน และรังสิมาภรณ์ หนูน้อย. (2567). การศึกษาความพึงพอใจของบุคลากรในสถานศึกษาที่มีต่อคุณภาพของนักศึกษาปฏิบัติการสอนในสถานศึกษา 4 คณะศึกษาศาสตร์ มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร. ใน พราม อินพรม และธีรนันท์ ตันพานิช (บ.ก.). การประชุมวิชาการแห่งชาติ ครั้งที่ 37 สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย (น. 356- 370). สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย. ',
              'year': 2568
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'พลศึกษา, เซปักตะกร้อ'
      },
      {
        'faculty': 'คณะศึกษาศาสตร์',
        'graduated': {
          'field': [ 'ศิลปศาสตรมหาบัณฑิต (ศศ.ม.)  สาขาพลศึกษา', 'วิทยาศาสตรบัณฑิต (วท.บ.) สาขาวิทยาศาสตร์การกีฬา' ],
          'university': [ 'มหาวิทยาลัยเกษตรศาสตร์', 'สถาบันการพลศึกษา' ]
        },
        'name': 'นายวศิน โต๊ะแสง',
        'position': '',
        'publish': {
          '2560': [],
          '2561': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'พลศึกษา, เทนนิส'
      },
      {
        'faculty': 'คณะศึกษาศาสตร์',
        'graduated': {
          'field': [ 'สาธารณสุขศาสตรมหาบัณฑิต (ส.ม.) สาขาสุขศึกษาและส่งเสริมสุขภาพ', 'วิทยาศาสตรบัณฑิต (วท.บ.) สาขาสุขศึกษา' ],
          'university': [ 'มหาวิทยาลัยมหิดล', 'มหาวิทยาลัยศรีนครินทรวิโรฒ' ]
        },
        'name': 'นางสาวเบญจมาศ พูลสวัสดิ์',
        'position': '',
        'publish': {
          '2560': [],
          '2561': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'สุขศึกษา'
      },
      {
        'faculty': 'คณะศึกษาศาสตร์',
        'graduated': {
          'field': [ 'ศึกษาศาสตรมหาบัณฑิต (ศษ.ม.) สาขาพลศึกษา', 'ศึกษาศาสตรบัณฑิต (ศษ.บ.) สาขาพลศึกษา' ],
          'university': [ 'สถาบันการพลศึกษา', 'มหาวิทยาลัยการกีฬาแห่งชาติ' ]
        },
        'name': 'นายเจนวิทย์  ดิษขนาน',
        'position': '',
        'publish': {
          '2560': [],
          '2561': [],
          '2562': [
            {
              'link': 'https://drive.google.com/file/d/1eA7C9DeJdQtIkP8ByVVxXDg3KFySF5_J/view?usp=sharing',
              'name': 'รายาศิต เต็งกูสุลัยมาน และคณะ. (2563). มโนมติการเข้าร่วมฝึกซ้อมกีฬาอาชีพสังกัดสโมสรฟุตบอล  3  จังหวัดชายแดนใต้. วารสารวิชาการ มหาวิทยาลัยการกีฬาแห่งชาติ. 12(1). p.225 – 237.',
              'year': 2562
            }
          ],
          '2563': [],
          '2564': [
            {
              'link': '',
              'name': 'รังสิมาภรณ์ หนูน้อย และคณะ (2564) ปัจจัยที่มีผลต่อการเป็นนักกีฬาอีสปอร์ต มหาวิทยาลัยการกีฬาแห่งชาติ วารสารคณะพลศึกษา มหาวิทยาลัยศรีนครินทร  วิโรฒ. 24(2) . หน้า 70-79.',
              'year': 2564
            }
          ],
          '2565': [],
          '2566': [
            {
              'link': '',
              'name': 'อนุรักษ์ ปักการะนัง, ดามพ์ สุขสุวานนท์, เจนวิทย์ ดิษขนาน, รังสิมาภรณ์ หนูน้อย, กาญจนา ฐานะ, เฉลิมพล ก่อกิจเถกิงกูล, ฤทัย เพชรสุวรรณ, สันติพร เชื้อไทย และนฤมล รอดเนียม. (2566). การศึกษาความต้องการของผู้ใช้บัณฑิตต่อคุณลักษณะบัณฑิตหลักสูตรศึกษาศาสตรบัณฑิต สาขาพลศึกษา มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร. ใน พราม อินพรม และธีรนันท์ ตันพานิช (บ.ก.). การประชุมวิชาการแห่งชาติ สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย (น. 300- 310). สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย.',
              'year': 2566
            }
          ],
          '2567': [
            {
              'link': 'https://so01.tci-thaijo.org/index.php/rdi-aru/article/download/276253/178869/1115407',
              'name': 'รังสิมาภรณ์ หนูน้อย และเจนวิทย์  ดิษขนาน. (2567). การพัฒนาแบบวัดทักษะกีฬากาบัดดี้สำหรับนักศึกษามหาวิทยาลัยการกีฬาแห่งชาติ. วารสารวิจัยราชภัฏกรุงเก่า, 11(3), หน้า 28 - 36.',
              'year': 2567
            }
          ],
          '2568': [
            {
              'link': '',
              'name': 'ฤทัย เพชรสุวรรณ, กาญจนา ฐานะ, เจนวิทย์ ดิษขนาน และรังสิมาภรณ์ หนูน้อย. (2567). การศึกษาความพึงพอใจของบุคลากรในสถานศึกษาที่มีต่อคุณภาพของนักศึกษาปฏิบัติการสอนในสถานศึกษา 4 คณะศึกษาศาสตร์ มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร. ใน พราม อินพรม และธีรนันท์ ตันพานิช (บ.ก.). การประชุมวิชาการแห่งชาติ ครั้งที่ 37 สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย (น. 356- 370). สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย. ',
              'year': 2568
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [
            {
              'budget': '50000',
              'doc': 'https://drive.google.com/file/d/1lc3dyu1BlTIs4p3mXwrMqUnjulk78PI7/view?usp=sharing',
              'name': 'เจนวิทย์  ดิษขนาน และรังสิมาภรณ์  หนูน้อย. (2564). ผลกระทบของสถานการร์การแพร่ระบาดของโรคติดเชื้อไวรัสโคโรนา 2019 ที่มีต่อนักกีฬากาบัดดี้. ชุมพร: มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยหลัก',
              'year': 2564
            }
          ],
          '2565': [],
          '2566': [
            {
              'budget': '28100',
              'doc': '',
              'name': 'รังสิมาภรณ์ หนูน้อย และเจนวิทย์  ดิษขนาน. (2567). การพัฒนาแบบวัดทักษะกีฬากาบัดดี้ สำหรับนักศึกษามหาวิทยาลัยการกีฬาแห่งชาติ. ชุมพร: มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยร่วม',
              'year': 2566
            }
          ],
          '2567': [],
          '2568': [
            {
              'budget': '196,000',
              'doc': '',
              'name': 'รังสิมาภรณ์ หนูน้อย จิราภรณ์  ขาวศรี และเจนวิทย์  ดิษขนาน. (2568). การพัฒนาแบบวัดทักษะการคิดเชิงบริหารสำหรับนักศึกษามหาวิทยาลัยการกีฬาแห่งชาติ. ชุมพร: มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร.',
              'role': 'ผู้วิจัยร่วม',
              'year': 2568
            }
          ]
        },
        'specialization': 'พลศึกษา,กาบัดดี้'
      },
      {
        'faculty': 'คณะศึกษาศาสตร์',
        'graduated': {
          'field': [ 'ศึกษาศาสตรมหาบัณฑิต (ศษ.ม.) สาขาพลศึกษา', 'ศึกษาศาสตรบัณฑิต (ศษ.บ.) สาขาพลศึกษา' ],
          'university': [ 'สถาบันการพลศึกษา', 'มหาวิทยาลัยการกีฬาแห่งชาติ' ]
        },
        'name': 'นายสันติพร  เชื้อไทย',
        'position': '',
        'publish': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': [],
          '2566': [
            {
              'link': '',
              'name': 'อนุรักษ์ ปักการะนัง, ดามพ์ สุขสุวานนท์, เจนวิทย์ ดิษขนาน, รังสิมาภรณ์ หนูน้อย, กาญจนา ฐานะ, เฉลิมพล ก่อกิจเถกิงกูล, ฤทัย เพชรสุวรรณ, สันติพร เชื้อไทย และนฤมล รอดเนียม. (2566). การศึกษาความต้องการของผู้ใช้บัณฑิตต่อคุณลักษณะบัณฑิตหลักสูตรศึกษาศาสตรบัณฑิต สาขาพลศึกษา มหาวิทยาลัยการกีฬาแห่งชาติ วิทยาเขตชุมพร. ใน พราม อินพรม และธีรนันท์ ตันพานิช (บ.ก.). การประชุมวิชาการแห่งชาติ สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย (น. 300- 310). สมาคมสุขศึกษา พลศึกษา และสันทนาการแห่งประเทศไทย.',
              'year': 2566
            }
          ]
        },
        'research': {
          '2560': [],
          '2561': [],
          '2562': [],
          '2563': [],
          '2564': [],
          '2565': []
        },
        'specialization': 'พลศึกษา,กาบัดดี้'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/data/personnel.js